<template>
  <div class="calendar-wrapper">
    <div
      class="calendar"
      :class="{ 'calendar--fullscreen': fullScreenCalendar }"
    >
      <div class="calendar-header">
        <div class="title-and-date" v-if="!fullScreenCalendar">
          <span
            @mousedown="isLeftPanelOpen = !isLeftPanelOpen"
            class="tms left-panel-toggle"
            :class="{ 'tms--active': isLeftPanelOpen }"
            >5</span
          >
          <section class="icon-and-text">
            <h2 class="desktop">{{ $t("planning") }}</h2>
            <div class="selected-date">
              <p v-if="activePeriodTab === 'day'">
                <strong>{{ date | formatDayYear }}</strong>
              </p>
              <p v-else-if="activePeriodTab === 'week'">
                <strong>{{ firstDay | formatDayYear }}</strong>
                -
                <strong>{{ lastDay | formatDayYear }}</strong>
              </p>
              <p v-else-if="activePeriodTab === 'month'">
                <strong
                  >{{ firstDay | getMonth }}
                  {{ firstDay.getFullYear() }}</strong
                >
              </p>
            </div>
          </section>
        </div>
        <div class="calendar-header-left" v-click-outside="closeFilters">
          <div v-if="isMobile" class="views views--settings">
            <span
              v-if="!fullScreenCalendar"
              @mousedown="isPlanningFiltersOpen = !isPlanningFiltersOpen"
              class="view"
              :class="{ 'view--active': isPlanningFiltersOpen }"
            >
              <span class="tms">I</span>
            </span>
            <button
              @mousedown="
                (fullScreenCalendar = !fullScreenCalendar),
                  (isPlanningFiltersOpen = false)
              "
              class="view view--fullscreen"
              :class="{ 'view--active': fullScreenCalendar }"
            >
              <span class="tms">.</span>
            </button>
          </div>
          <div
            class="filters"
            :class="{ 'filters--open': isPlanningFiltersOpen }"
          >
            <template v-if="activeContentTab !== 'hr'">
              <Checkbox
                v-if="!basicView"
                title="Временно показване на имената на служителите по групи"
                :value="planningFilters['showGroupUsers']"
                @input="togglePlanningFilter('showGroupUsers')"
                label="Покажи служителите в групата"
              />
              <Checkbox
                title="Временно показване на групите с подизпълнители"
                :value="planningFilters['showWorkerGroups']"
                @input="togglePlanningFilter('showWorkerGroups')"
                :disabled="activeContentTab === 'object'"
                label="Покажи групи подизпълнители"
              />
              <Checkbox
                v-if="!basicView"
                title="Показват се само НЕОТЧЕТЕНИТЕ служители - това са планирани служители, които не са отчетени и нямат активен отпуск"
                :value="planningFilters['showOnlyUnReported']"
                @input="togglePlanningFilter('showOnlyUnReported')"
                label="Покажи само неотчетените"
              />
              <Checkbox
                title="Групите ще се сортират, като първо ще се покажат тези, в които има планиране"
                :value="planningFilters['showPlannedGroupsFirst']"
                @input="togglePlanningFilter('showPlannedGroupsFirst')"
                label="Покажи първо планираните групи"
              />
            </template>
            <template v-else>
              <Checkbox
                label="Покажи само неотчетените"
                v-model="showOnlyUnReportedAbsences"
                @input="showOnlyReportedAbsences = false"
              />
              <Checkbox
                label="Виж отчетените"
                v-model="showOnlyReportedAbsences"
                @input="showOnlyUnReportedAbsences = false"
              />
            </template>
          </div>
          <div class="btns" v-if="activeContentTab === 'hr'">
            <a
              class="btn btn-excel btn-widthless"
              :href="normativeUrl"
              target="_blank"
              @click="toggleExport($event)"
            >
              <span class="tms">E</span>
              <p class="desktop">Справка Норматив м. {{ date | getMonth }}</p>
            </a>
            <!-- <a class="btn btn--help" :href="normativePdf" target="_blank">?</a> -->
          </div>
          <div class="views" id="views1" v-if="!fullScreenCalendar">
            <button
              class="view right"
              :class="{ 'view--active': basicView }"
              @click="toggleBasicView()"
            >
              <span class="tms">\</span>
              <span>График</span>
            </button>
            <button
              class="view"
              :class="{ 'view--active': activePeriodTab === 'day' }"
              @click="changePeriodTab('day')"
            >
              <span class="tms">4</span>
              <span>{{ $t("day") }}</span>
            </button>
            <button
              class="view"
              :class="{ 'view--active': activePeriodTab === 'week' }"
              @click="changePeriodTab('week')"
            >
              <span class="tms">7</span>
              <span>{{ $t(`${isMobile ? "week-short" : "week"}`) }}</span>
            </button>
            <button
              class="view"
              :class="{
                'view--active': activePeriodTab === 'month' && !basicView,
              }"
              @click="
                changePeriodTab('month'), basicView ? (basicView = false) : null
              "
            >
              <span class="tms">6</span>
              <span>Месец</span>
            </button>
          </div>
        </div>
      </div>
      <div class="calendar-content">
        <section class="left-panel-wrapper">
          <div
            class="left-panel"
            :class="{
              'left-panel-week-mode': activePeriodTab === 'week',
              'left-panel-day-mode': activePeriodTab === 'day',
              'left-panel--open': isLeftPanelOpen,
            }"
            v-click-outside="closePanel"
          >
            <div class="left-panel-header">
              <div class="views" id="views2">
                <p>ИЗГЛЕД ПО</p>
                <button
                  class="view left"
                  :class="{ 'view--active': activeContentTab === 'object' }"
                  @click="changeContentTab('object')"
                >
                  Обекти
                </button>
                <button
                  class="view left"
                  :class="{ 'view--active': activeContentTab === 'group' }"
                  @click="changeContentTab('group')"
                >
                  Групи
                </button>
                <button
                  class="view right"
                  :class="{ 'view--active': activeContentTab === 'hr' }"
                  @click="changeContentTab('hr')"
                >
                  ЧР
                </button>
              </div>
            </div>
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :minimumView="'day'"
              :highlighted="highlighted"
              :maximumView="'day'"
              :full-month-name="true"
              v-model="date"
            ></datepicker>

            <div class="datepicker-legend">
              <div>
                <span>{{ new Date().getDate() }}</span>
                <p>Днес</p>
              </div>
              <div>
                <span>{{ new Date().getDate() }}</span>
                <p>Ден с планиране</p>
              </div>
              <div>
                <span>{{
                  activePeriodTab === "day"
                    ? date
                      ? date.getDate()
                      : 1
                    : firstDay
                    ? firstDay.getDate()
                    : 1
                }}</span>
                <p>Избран ден/седмица</p>
              </div>
            </div>
            <div class="stages-legend">
              <img
                v-if="activeContentTab === 'group'"
                src="../assets/img/legend-gr.svg"
                alt=""
              />
              <img
                v-else-if="activeContentTab === 'object'"
                src="../assets/img/legend-ob.svg"
                alt=""
              />
              <img v-else src="../assets/img/legend-hr.svg" alt="" />
            </div>
          </div>
        </section>
        <div class="right-panel" id="rightPanel">
          <div class="new-days" v-if="activePeriodTab === 'day'">
            <template v-if="activeContentTab === 'group'">
              <template v-if="date">
                <div
                  class="days-item"
                  :class="{
                    'days-item--non-planned': g.plannings
                      ? !g.plannings.length
                      : true,
                    'days-item--reported': checkIfGroupsIsReported(g),
                  }"
                  v-for="(g, gi) in groupsPlannings[
                    new Date(date).toISOString().slice(0, 10)
                  ]"
                  :key="g._id"
                >
                  <header
                    :class="{
                      'header--day': activePeriodTab === 'day',
                      'header--show-users': planningFilters['showGroupUsers'],
                      'header--rotate':
                        isMobile && !planningFilters['showGroupUsers'],
                    }"
                  >
                    <span v-if="g.isWorkerGroup" class="tms tms--brown">1</span>
                    <span v-else class="tms">0</span>
                    <p :title="getGroupName(g)">
                      {{ getGroupName(g) }}
                    </p>

                    <div
                      class="header-group-users"
                      v-if="planningFilters['showGroupUsers']"
                    >
                      <p
                        v-for="u in g.users"
                        :key="u._id"
                        class="group-user"
                        :class="
                          g.isWorkerGroup
                            ? 'group-user--worker-group'
                            : getGroupUserClass(g, u._id)
                        "
                      >
                        {{ u.name }}
                      </p>
                    </div>
                  </header>

                  <template v-if="g.loaded">
                    <div
                      class="planned-objects"
                      v-if="g.plannings && g.plannings.length"
                    >
                      <PlanningItem
                        v-for="(p, i) in g.plannings"
                        :key="g._id + i"
                        :p="p"
                        :index="gi"
                        :chosenPlan="chosenPlan"
                        :period="activePeriodTab"
                        @updatePlan="updatePlan(p)"
                        @setPlanGroup="planGroup = g"
                        @openCopyMoveCalendarModal="openCopyMoveCalendarModal"
                        @openMaterials="openMaterials"
                        @openTransport="openTransport"
                        @editPlanning="editPlanning"
                        @removeGroupFromPlan="removeGroupFromPlan(g, p)"
                        @proceedToNextStep="proceedToNextStep"
                        @openCreateReport="openCreateReport"
                        @removePlanning="removePlanning"
                      />
                    </div>
                  </template>
                  <div
                    class="planning-toggle planning-toggle--pink"
                    @click="planGroup = g"
                    title="Добави един или повече обекти за тази група."
                  >
                    <span class="tms">!</span>
                    <p>Планирай обект</p>
                  </div>
                </div>
              </template>
            </template>
            <template v-if="activeContentTab === 'object'">
              <div class="planning-toggle" @click="newPlanning = true">
                <span class="tms">!</span>
                <p>Планирай обект</p>
              </div>
              <PlanningItem
                v-for="(p, pi) in plannings"
                :key="p._id + pi + planningFilters['showOnlyUnReported']"
                :p="p"
                :chosenPlan="chosenPlan"
                :fromObjects="true"
                :period="activePeriodTab"
                :showOnlyUnReported="planningFilters['showOnlyUnReported']"
                :showGroupUsers="planningFilters['showGroupUsers']"
                @updatePlan="updatePlan(p)"
                @openCopyMoveCalendarModal="openCopyMoveCalendarModal"
                @openCalendarGroupModal="openCalendarGroupModal"
                @openMaterials="openMaterials"
                @openTransport="openTransport"
                @editPlanning="editPlanning"
                @removePlanning="removePlanning"
                @proceedToNextStep="proceedToNextStep"
                @openCreateReport="openCreateReport"
              />
            </template>
            <div class="absences-wrapper" v-if="activeContentTab === 'hr'">
              <div
                class="add-row"
                @click="
                  getUser.permissions.isEmployee ? null : openAddAbsencesModal()
                "
              >
                <span class="icon">+</span>
                <p>Добавяне на отсъствия</p>
              </div>

              <template v-if="!absences.length">
                <p class="no-results-calendar-p">
                  {{ $t("no-results-for") }} {{ this.date | formatDate }}
                </p>
              </template>
              <template v-else>
                <p
                  class="absence-row"
                  v-for="a in filteredAbsences"
                  :key="a._id"
                  @click="
                    a.type === 'unreported' || a.type === 'reported'
                      ? null
                      : (selectedAbsence = a._id)
                  "
                  v-show="
                    showOnlyUnReportedAbsences
                      ? a.type === 'unreported'
                      : showOnlyReportedAbsences
                      ? a.type === 'reported'
                      : true
                  "
                >
                  <span class="state-type" :class="`state-type--${a.type}`">{{
                    absenceTypes[a.type]
                  }}</span>
                  <span class="abscence-name">
                    <strong>{{ a.user.name }}</strong>
                  </span>
                  <span
                    >{{ a.from | formatDayYear }} -
                    {{ a.to | formatDayYear }}</span
                  >
                </p>
              </template>
            </div>
          </div>
          <!-- week and month views -->
          <template v-else>
            <div
              class="days"
              id="weekAndMonthDays"
              @scroll="scrolling"
              :class="{
                'days--basic-view': basicView,
                'days--groups': activeContentTab === 'group',
                'days--show-group-users': planningFilters['showGroupUsers'],
              }"
            >
              <!-- :class="{ 'days--grid': activePeriodTab === 'month' }" -->
              <section
                class="days-item days-item--groups-aside"
                :style="stickyGroups ? { left: stickyGroups } : ''"
                v-if="activeContentTab === 'group'"
              >
                <header
                  :class="{
                    'header--show-users': planningFilters['showGroupUsers'],
                    'header--rotate':
                      isMobile && !planningFilters['showGroupUsers'],
                  }"
                  v-for="(g, gi) of groups"
                  :key="`${g._id}-${gi}`"
                  :id="`${g._id}-${gi}`"
                >
                  <span v-if="g.isWorkerGroup" class="tms tms--brown">1</span>
                  <span v-else class="tms">0</span>
                  <p :title="getGroupName(g)">{{ getGroupName(g) }}</p>

                  <div
                    class="header-group-users"
                    v-if="planningFilters['showGroupUsers']"
                  >
                    <p
                      v-for="u in g.users"
                      :key="u._id"
                      class="group-user group-user--worker-group"
                    >
                      {{ u.name }}
                    </p>
                  </div>
                </header>
              </section>

              <div
                class="day-item"
                :class="{
                  'day-item--weekend': checkIsWeekend(new Date(d)),
                  'day-item--object': activeContentTab === 'object',
                }"
                v-for="d in datesOfPeriod"
                :key="`month-day-group-${d}`"
              >
                <header :style="stickyHeader ? { top: stickyHeader } : ''">
                  <p>
                    {{ getDayNameShort(d) }}
                    <strong>{{ getDayOfMonth(d) }} </strong>
                  </p>
                </header>

                <main>
                  <div class="plans" v-if="activeContentTab !== 'hr'">
                    <template v-if="activeContentTab === 'group'">
                      <div
                        v-show="contentLoaded"
                        v-for="(g, gi) in groupsPlannings[
                          new Date(d).toISOString().slice(0, 10)
                        ]"
                        :key="`${g._id}-${gi}-${d.getTime()}`"
                        class="group-content"
                      >
                        <div
                          class="content"
                          @mouseenter="handleGroupPlansMouseEnter(g, d)"
                          @mouseleave="handleGroupPlansMouseLeave(g)"
                          @click.stop="groupContentClick(g, d)"
                          :class="getContentClass(g, d)"
                        >
                          <main
                            class="content__wrap"
                            :class="{'content__wrap--last': gi === groupsPlannings[
                          new Date(d).toISOString().slice(0, 10)
                        ].length - 1}"
                            v-click-outside="
                              () =>
                                g.hovered ? handlePlansHover(g, false) : null
                            "
                          >
                            <div
                              v-if="basicView ? !g.plannings.length : true"
                              class="planning-toggle planning-toggle--pink"
                              :class="{
                                'planning-toggle-small': !g.plannings.length,
                              }"
                              @click="
                                Object.entries(selectedPlanDays).length
                                  ? null
                                  : (planGroup = g),
                                  (selectedDate = d)
                              "
                              title="Добави един или повече обекти за тази група."
                            >
                              <div
                                class="plans-count"
                                :class="{
                                  'plans-count--big':
                                    !plansCount[g.plannings.length],
                                }"
                                v-if="g.plannings.length && !g.hovered"
                              >
                                {{ plansCount[g.plannings.length] || "❻" }}
                              </div>
                              <span class="tms">!</span>
                              <p v-if="g.hovered">Планирай обект</p>
                            </div>

                            <section class="plans__wrapper">
                              <PlanningItem
                                v-show="p"
                                v-for="(p, pi) in g.plannings"
                                :key="g._id + pi"
                                :p="p"
                                :small="g.hovered ? false : true"
                                @planDirectionLeft="
                                  ($event) => (g.left = $event)
                                "
                                :inBasicView="g.hovered ? false : true"
                                :ignoreGetHeight="g.hovered ? true : false"
                                @updatePlan="updatePlan(p)"
                                @selectPlanning="selectPlanning(p, gi)"
                                @setPlanGroup="planGroup = g"
                                @openCopyMoveCalendarModal="
                                  openCopyMoveCalendarModal
                                "
                                @removeGroupFromPlan="removeGroupFromPlan(g, p)"
                                @openMaterials="openMaterials"
                                @openTransport="openTransport"
                                @editPlanning="editPlanning"
                                @proceedToNextStep="proceedToNextStep"
                                @openCreateReport="openCreateReport"
                                @removePlanning="removePlanning"
                              />
                            </section>
                          </main>
                        </div>
                      </div>
                    </template>

                    <template v-else>
                      <div
                        class="planning-toggle"
                        @click="(newPlanning = true), (selectedDate = d)"
                        title="Добави един или повече обекти за тази група."
                      >
                        <span class="tms">!</span>
                        <p>Планирай обект</p>
                      </div>
                      <PlanningItem
                        v-for="p in planningsByDate[
                          d.toISOString().slice(0, 10)
                        ]"
                        :key="p._id"
                        :p="p"
                        :fromObjects="true"
                        :small="true"
                        :showGroupUsers="planningFilters['showGroupUsers']"
                        @updatePlan="updatePlan(p)"
                        @selectPlanning="selectPlanning(p)"
                        @setPlanGroup="planGroup = g"
                        @openCopyMoveCalendarModal="openCopyMoveCalendarModal"
                        @openCalendarGroupModal="openCalendarGroupModal"
                        @openMaterials="openMaterials"
                        @openTransport="openTransport"
                        @editPlanning="editPlanning"
                        @removePlanning="removePlanning"
                        @proceedToNextStep="proceedToNextStep"
                        @openCreateReport="openCreateReport"
                      />
                    </template>
                  </div>
                  <div class="plans" v-if="activeContentTab === 'hr'">
                    <p
                      v-for="p in absencesByDate[d.toISOString().slice(0, 10)]"
                      :key="p._id"
                      class="state-type"
                      :class="`state-type--${p.type}`"
                      @click="
                        p.type === 'unreported' || p.type === 'reported'
                          ? null
                          : (selectedAbsence = p._id)
                      "
                      v-show="
                        showOnlyUnReportedAbsences
                          ? p.type === 'unreported'
                          : showOnlyReportedAbsences
                          ? p.type === 'reported'
                          : true
                      "
                    >
                      {{ p.user.name }}
                    </p>
                  </div>
                </main>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <transition name="fade">
      <AddUsersModal
        v-if="isWorkersModalOpen"
        :allUsers="true"
        :incomingUsers="plannings[selectedPlanning].groups"
        :usersType="'groups'"
      />
    </transition> -->
    <transition name="fade">
      <AddCompaniesModal v-if="isAddCompaniesModalOpened" />
    </transition>
    <transition name="fade">
      <CopyMoveCalendarModal
        v-if="CopyMoveCalendarModalAction"
        :action="CopyMoveCalendarModalAction"
        :id="CopyMoveCalendarModalCalendar"
        @close="closeCopyMoveCalendarModal"
      />
    </transition>
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :isCommingFromReport="true"
        :companyId="selectedPlanning.company._id"
        :objectId="selectedPlanning.object._id"
        :incomingMaterials="selectedObjectMaterials"
        @getMaterialsAgain="getMaterials"
      />
      <!-- :partId="selectedPlanning.part._id" -->
    </transition>
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :isCommingFromReport="true"
        :companyId="selectedIds.companyId"
        :objectId="selectedIds.objectId"
        :partId="selectedIds.partId"
        :incomingMechanizations="selectedObjectMechanizations"
      />
    </transition>
    <transition name="fade">
      <AddQuantityModal v-if="addQuantityTo" :val="addQuantityTo" />
    </transition>
    <transition name="fade">
      <AddAbsencesModal
        v-if="isAbsencesModalOpen"
        :selectedCalendarDate="date"
        @close="closeAbsencesModal"
      />
    </transition>
    <transition name="fade">
      <EditAbsenceModal
        v-if="selectedAbsence"
        :id="selectedAbsence"
        @close="closeEditAbscenceModal"
      />
    </transition>
    <transition name="fade">
      <CalendarObjectModal
        v-if="planGroup || newPlanning"
        :group="planGroup"
        :date="selectedDate ? selectedDate : date"
        @close="closeCalendarObjectModal"
      />
    </transition>
    <transition name="fade">
      <CalendarGroupModal
        v-if="isCalendarGroupModalOpen"
        :planning="selectedPlanning"
        @close="closeCalendarGroupModal"
      />
    </transition>
    <transition name="fade">
      <CalendarTransportModal
        v-if="isCalendarTransportModalOpen"
        :planning="selectedPlanning"
        @close="closeCalendarTransportModal"
      />
    </transition>
  </div>
</template>

<script>
// import print from "print-js";
// import AddUsersModal from "./shared/AddUsersModal";
// import axios from "axios";
import PlanningItem from "./shared/PlanningItem";
import AddCompaniesModal from "./shared/AddCompaniesModal";
import CopyMoveCalendarModal from "./shared/CopyMoveCalendarModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddMechanizationsModal from "./shared/AddMechanizationsModal";
import AddQuantityModal from "./shared/AddQuantityModal";
import AddAbsencesModal from "./shared/AddAbsencesModal.vue";
import EditAbsenceModal from "./shared/EditAbsenceModal";
import CalendarObjectModal from "./shared/CalendarObjectModal";
import CalendarGroupModal from "./shared/CalendarGroupModal";
import CalendarTransportModal from "./shared/CalendarTransportModal";
import { format, isWeekend } from "date-fns";
import Checkbox from "./shared/Checkbox";
import Datepicker from "vuejs-datepicker";
import Vue from "vue";
import { bg } from "vuejs-datepicker/dist/locale";`
import { format } from "date-fns";`
import bgLocale from "date-fns/locale/bg";
import { mapGetters } from "vuex";
import log from "./mixins/log.js";
export default {
  components: {
    Datepicker,
    // AddUsersModal,
    AddCompaniesModal,
    CopyMoveCalendarModal,
    AddMaterialsModal,
    AddMechanizationsModal,
    AddQuantityModal,
    AddAbsencesModal,
    EditAbsenceModal,
    CalendarObjectModal,
    CalendarGroupModal,
    CalendarTransportModal,
    Checkbox,
    PlanningItem,
  },
  mixins: [log],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      "getLoading",
      // ...
    ]),
    normativeUrl() {
      return `${
        process.env.VUE_APP_BASE_URI
      }/normative/${this.date.toISOString()}`;
    },
    datesOfPeriod() {
      // const dates = [];

      let from = this.date;
      let to = this.date;
      if (this.basicView) {
        from = from.GetFirstDayOfWeek();
        from.setHours(0, 0, 0, 0);
        to = new Date(from);
        to.setMonth(to.getMonth() + 1);
      } else if (this.activePeriodTab === "week") {
        from = new Date(this.date).GetFirstDayOfWeek();
        to = new Date(this.date).GetLastDayOfWeek();
      } else if (this.activePeriodTab === "month") {
        from = new Date(this.date).GetFirstDayOfMonth();
        to = new Date(this.date).GetLastDayOfMonth();

        if (this.activeContentTab === "object") {
          from = new Date(from.setHours(12, 0, 0, 0));
          to = new Date(to.setHours(23, 59, 59, 999));
        }
      }

      const dates = this.getDates(from, to);
      // while (from <= to) {
      //   dates.push(new Date(from));
      //   from = new Date(from.setDate(from.getDate() + 1));
      // }

      return dates;
    },
    planningsByDate() {
      const plannings = {};

      if (this.plannings ? this.plannings.length : false) {
        for (let p of this.plannings) {
          const d = p.date.slice(0, 10);
          if (!plannings[d]) plannings[d] = [];
          plannings[d].push(p);
        }
      }

      return plannings;
    },
    absencesByDate() {
      const absences = {};

      if (this.filteredAbsences ? this.filteredAbsences.length : false) {
        for (let a of this.filteredAbsences) {
          let dateFrom = new Date(a.from);
          let dateTo = new Date(a.to);
          dateFrom.setHours(12, 0, 0, 0);
          dateTo.setHours(23, 59, 59, 999);

          for (
            let day = dateFrom;
            day <= new Date(dateTo);
            day.setDate(day.getDate() + 1)
          ) {
            const d = day.toISOString().slice(0, 10);
            if (!absences[d]) absences[d] = [];
            absences[d].push(a);
          }
        }
      }

      return absences;
    },
    filteredAbsences() {
      if (this.showOnlyReportedAbsences)
        return this.absences.filter((a) => a.type === "reported");
      else return this.absences.filter((a) => a.type !== "reported");
    },
  },
  data() {
    return {
      bg: bg,
      bgLocale: bgLocale,
      months: this.$t("months"),
      highlightedDates: [],
      highlighted: { to: "", from: "" },
      date: "",
      selectedDate: undefined,
      chosenPlan: undefined,
      isMobile: false,
      contentLoaded: false,
      isLeftPanelOpen: false,
      basicView: false,
      stickyHeader: false,
      stickyGroups: false,
      isPlanningFiltersOpen: false,
      fullScreenCalendar: false,
      firstDay: undefined,
      lastDay: undefined,
      format: "MMMM yyyy",
      activePeriodTab: "day",
      activeContentTab: "object",
      selectedAbsence: "",
      selectedPlanDays: {},
      selectedDays: {},
      isSelectingPlans: false,
      isSelectingDays: false,
      calendars: [],
      plannings: [],
      groupsPlannings: [],
      groups: [],
      showOnlyUnReportedAbsences: false,
      showOnlyReportedAbsences: false,
      absences: [],
      absenceTypes: {
        paid: "Платен отпуск",
        unpaid: "Неплатен отпуск",
        illness: "Отпуск по болест",
        compensation: "Самоотлъчка",
        unreported: "Неотчетен служител",
        reported: "Отчетен",
      },
      plansCount: {
        1: "❶",
        2: "❷",
        3: "❸",
        4: "❹",
        5: "❺",
        6: "❻",
      },
      workers: [],
      planningFilters: {
        showWorkerGroups: true,
      },
      allowExport: false,
      isAbsencesModalOpen: false,
      isAddCompaniesModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddMechanizationsModalOpened: false,
      selectedObject: undefined,
      CopyMoveCalendarModalAction: "",
      CopyMoveCalendarModalCalendar: undefined,
      showMobileDatepicker: false,
      selectedObjectMaterials: [],
      selectedObjectMechanizations: [],
      selectedIds: {
        companyId: null,
        partId: null,
        objectId: null,
        partIndex: null,
        type: null,
      },
      addQuantityTo: null,
      planGroup: null,
      newPlanning: false,
      selectedPlanning: null,
      isCalendarGroupModalOpen: false,
      isCalendarTransportModalOpen: false,
    };
  },
  watch: {
    date() {
      this.showMobileDatepicker = false;
      // this.getCalendars();
      this.fetchData();
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();

      if (this.activePeriodTab === "week") {
        this.highlighted = {
          from: this.firstDay,
          to: this.lastDay,
          additional: this.highlightedDates,
        };
      } else {
        this.highlighted = {
          additional: this.highlightedDates,
        };
      }
    },
  },
  methods: {
    checkIsWeekend(d) {
      return isWeekend(d);
    },
    getDayNameShort(d) {
      return format(new Date(d), "E", { locale: this.bgLocale });
    },
    getDayOfMonth(d) {
      return format(new Date(d), "d/M");
    },
    scrolling() {
      if (this.activePeriodTab !== "day") {
        let wrapper = document.getElementById("weekAndMonthDays");

        if (wrapper.scrollTop > 0) {
          this.stickyHeader = `${wrapper.scrollTop - 5}px`;
        } else this.stickyHeader = false;

        if (wrapper.scrollLeft > 0) {
          this.stickyGroups = `${wrapper.scrollLeft}px`;
        } else this.stickyGroups = false;
      }
    },
    getHeight(gId, i) {
      setTimeout(() => {
        let groupHeader = document.getElementById(`${gId}-${i}`);
        let plansWrap = document.getElementsByClassName(`plans-wrap-${gId}`);

        if (groupHeader && plansWrap) {
          for (let p of plansWrap) {
            p.style.height = `${groupHeader.offsetHeight}px`;
          }
        }
      }, 200);
    },
    getContentClass(g, d) {
      let cl = `plans-wrap-${g._id}`;
      if (g.plannings.length >= 2) {
        cl += " content--multiple";
      }
      if (g.plannings.length && !this.basicView) cl += " content--has-plans";
      if (this.selectedPlanDays[d]) {
        if (this.selectedPlanDays[d].includes(g._id))
          cl += " content--selected";
      }
      if (g.hovered) cl += " content--hovered";
      if (g.left && g.hovered) cl += " content--left";

      if (this.selectedDays[d] && this.selectedDays[d].includes(g._id))
        cl += " content--selected--add";

      return cl;
    },
    selectPlanning(p, index) {
      if (!this.basicView) {
        this.changePeriodTab("day");
        this.chosenPlan = p._id;
        if (index) this.chosenPlan = { index: index, plan: p._id };
        this.date = new Date(p.date);

        let getId = `${p._id}`;
        if (index) getId = `${index}-${p._id}`;

        setTimeout(
          () => {
            let elem = document.getElementById(getId);
            if (elem) {
              elem.scrollIntoView({
                block: "center",
                behavior: "smooth",
              });
            }
          },
          this.planningFilters["showGroupUsers"] ? 1000 : 500
        );

        setTimeout(() => {
          this.chosenPlan = undefined;
        }, 3000);
      }
    },
    openReport(reportId) {
      window.open(`/reports/edit/${reportId}`, "_blank");
    },
    checkIfGroupsIsReported(g) {
      if (g.plannings.length) {
        for (let p of g.plannings) {
          if (p.status === "reported") return true;
        }
      }
      return false;
    },
    toggleBasicView() {
      if (!this.getLoading) {
        this.basicView = !this.basicView;

        if (this.basicView) {
          this.changePeriodTab("month");
          this.activeContentTab = "group";
        }
        if (this.planningFilters["showGroupUsers"])
          this.planningFilters["showGroupUsers"] = false;
        if (this.planningFilters["showOnlyUnReported"])
          this.planningFilters["showOnlyUnReported"] = false;

        this.getGroups();
      }
    },
    changePeriodTab(p) {
      if (!this.getLoading) {
        this.resetCopyingPlans();
        if (p !== "month") this.basicView = false;
        this.showMobileDatepicker = false;
        this.firstDay = new Date(this.date).GetFirstDayOfWeek();
        this.lastDay = new Date(this.date).GetLastDayOfWeek();
        this.calendars = [];
        this.activePeriodTab = p;
        if (this.activePeriodTab === "week") {
          this.highlighted = {
            from: this.firstDay,
            to: this.lastDay,
            additional: this.highlightedDates,
          };
        } else {
          this.highlighted = {
            additional: this.highlightedDates,
          };
        }
        // this.getCalendars();
        this.fetchData();
      }
    },
    changeContentTab(c) {
      if (!this.getLoading) {
        this.resetCopyingPlans();
        if (this.basicView) this.basicView = false;
        this.activeContentTab = c;
        this.filter = null;
        if (this.activeContentTab === "object")
          this.planningFilters.showWorkerGroups = true;
        else delete this.planningFilters.showWorkerGroups;
        this.fetchData();
      }
    },
    fetchData() {
      this.isLeftPanelOpen = false;
      this.calendars = [];
      this.absences = [];
      this.groupsPlannings = {};
      this.plannings = [];
      if (this.activeContentTab === "hr") {
        this.getAbsences();
        this.getGroups(); // we use this to get unreported users
        this.exportPermission();
      } else if (this.activeContentTab === "group") {
        this.getGroups();
        // if (this.activePeriodTab === "day") this.getGroups();
        this.getPlannings();
        // this.getCalendars();
      } else if (this.activeContentTab === "object") {
        this.getPlannings();
      }
      this.getHighlighted();
    },
    exportPermission() {
      this.allowExport = false;
      let url = `${
        process.env.VUE_APP_BASE_URI
      }/normative/${this.date.toISOString()}?allow=true`;
      this.$http.get(url).then((response) => {
        this.allowExport = response.data;
      });
    },
    getAbsences() {
      let dateFrom = new Date(this.date);
      let dateTo = new Date(this.date);

      if (this.activePeriodTab === "week") {
        dateFrom = dateFrom.GetFirstDayOfWeek();
        dateTo = dateTo.GetLastDayOfWeek();
      } else if (this.activePeriodTab === "month") {
        dateFrom = dateFrom.GetFirstDayOfMonth();
        dateTo = dateTo.GetLastDayOfMonth();
      }

      let url = `${process.env.VUE_APP_BASE_URI}/absence/date/${dateFrom}/${dateTo}`;

      this.$http.get(url).then((res) => {
        this.absences = res.data;
      });
    },
    getDates(d1, d2) {
      const d = [];
      const start = new Date(d1);
      while (start <= d2) {
        // let dayOfWeek = getDay(new Date(start))

        // if (this.basicView && dayOfWeek == 0) {
        //   // dont include sunday in basicView
        // } else {
        //   d.push(new Date(start));
        // }
        d.push(new Date(start));
        start.setDate(start.getDate() + 1);
      }

      return d;
    },
    // gets groups and their plannings with the users statuses (planned,reported...)
    getGroups() {
      // let url = `${process.env.VUE_APP_BASE_URI}/group?active=true`;
      this.$store.dispatch("startLoading");
      this.contentLoaded = false;

      let dateFrom = new Date(this.date);
      let dateTo = new Date(this.date);

      if (this.basicView) {
        dateFrom = dateFrom.GetFirstDayOfWeek();
        dateFrom.setHours(0, 0, 0, 0);
        dateTo = new Date(dateFrom);
        dateTo.setMonth(dateTo.getMonth() + 1);
      } else if (this.activePeriodTab === "week") {
        dateFrom = dateFrom.GetFirstDayOfWeek();
        dateTo = dateTo.GetLastDayOfWeek();
      } else if (this.activePeriodTab === "month") {
        dateFrom = dateFrom.GetFirstDayOfMonth();
        dateTo = dateTo.GetLastDayOfMonth();
      }

      for (let d of this.getDates(dateFrom, dateTo)) {
        let url = `${
          process.env.VUE_APP_BASE_URI
        }/report/userStatuses/${d.toISOString()}/${d.toISOString()}/day?period=${
          this.activePeriodTab
        }&dateFrom=${dateFrom}&dateTo=${dateTo}`;

        let hasFilters = Object.keys(this.planningFilters).length
          ? true
          : false;

        if (hasFilters) {
          url += `&planningFilters=${Object.keys(this.planningFilters)}`;
        }

        this.$http.get(url).then(async (res) => {
          this.groups = res.data.groups;
          this.$set(
            this.groupsPlannings,
            d.toISOString().slice(0, 10),
            res.data.groups
          );

          let groupPlanningsByPeriod =
            this.groupsPlannings[d.toISOString().slice(0, 10)];

          for (let i = 0; i < groupPlanningsByPeriod.length; i++) {
            let g = groupPlanningsByPeriod[i];

            this.getReporters(g.plannings);

            // if (g.isWorkerGroup) {
            //   let worker = await axios.get(
            //     `${process.env.VUE_APP_BASE_URI}/auth/users/${g.worker}`
            //   );
            //   if (worker.data) g.worker = worker.data;
            // }

            if (
              this.activePeriodTab !== "day" &&
              this.activeContentTab === "group"
            ) {
              this.getHeight(g._id, i);
            }
          }

          if (res.data.absences.length) {
            this.absences = this.absences.concat(res.data.absences);
          }
          // this.getGroupPlanningsByDate();
        });
      }

      setTimeout(
        () => {
          // valid for basicView only
          this.contentLoaded = true;
          this.$store.dispatch("stopLoading");
        },
        this.basicView
          ? this.planningFilters["showWorkerGroups"]
            ? 3000
            : 1000
          : 0
      );
    },
    getPlannings() {
      this.$store.dispatch("startLoading");
      // let url = `${process.env.VUE_APP_BASE_URI}/planning`;

      // if (this.activePeriodTab === "day") {
      //   url += `/${this.date}`;
      // } else if (this.activePeriodTab === "week") {
      //   url += `/${new Date(this.date).GetFirstDayOfWeek().toISOString()}`;
      //   url += `/${new Date(this.date).GetLastDayOfWeek().toISOString()}`;
      // } else if (this.activePeriodTab === "month") {
      //   url += `/${new Date(this.date).GetFirstDayOfMonth().toISOString()}`;
      //   url += `/${new Date(this.date).GetLastDayOfMonth().toISOString()}`;
      // }

      // this.$http.get(url).then((res) => {
      //   this.plannings = res.data;
      // });
      let dateFrom = new Date(this.date);
      let dateTo = new Date(this.date);

      if (this.activePeriodTab === "week") {
        dateFrom = dateFrom.GetFirstDayOfWeek();
        dateTo = dateTo.GetLastDayOfWeek();
      } else if (this.activePeriodTab === "month") {
        dateFrom = dateFrom.GetFirstDayOfMonth();
        dateTo = dateTo.GetLastDayOfMonth();
      }

      let url = `${process.env.VUE_APP_BASE_URI}/report/userStatuses/${dateFrom}/${dateTo}`;

      let hasFilters = Object.keys(this.planningFilters).length ? true : false;

      if (hasFilters) {
        url += `?planningFilters=${Object.keys(this.planningFilters)}`;
      }

      this.$http.get(url).then((res) => {
        this.plannings = res.data;

        // this.getWhoIsReportedAndWhoIsNot();
        this.getReporters(this.plannings);

        if (this.planningFilters["showOnlyUnReported"]) {
          for (let p of this.plannings) {
            let notReportedArr = [];
            if (p.notReportedWorkers) notReportedArr = p.notReportedWorkers;

            for (let g of p.groups) {
              g.users = g.users.filter((x) => notReportedArr.includes(x._id));
            }
            if(p.users) {
              p.users= p.users.filter((x) => notReportedArr.includes(x._id));
            }
          }
        }

        this.$store.dispatch("stopLoading");
      });
    },

    getReporters(plannings) {
      if (!plannings) return;

      for (let p of plannings) {
        this.$http
          .get(
            `${process.env.VUE_APP_BASE_URI}/company/reporters/${p.company._id}/${p.object._id}`
          )
          .then((res) => {
            this.$set(p, "reporters", res.data);
          });
      }
    },
    getGroupName(g) {
      let name = g.name.replace("Група", "");
      if (g.isWorkerGroup) name = `${g.worker.name} - ${g.name}`;
      return name;
    },
    getGroupUserClass(p, id) {
      let statusArrays = [
        { plannedWorkers: "planned" },
        { reportedWorkers: "reported" },
        { addedWorkers: "nonplanned" },
        { movedWorkers: "moved" },
        { notReportedWorkers: "not-reported" },
      ];

      for (let s of statusArrays) {
        let key = Object.keys(s)[0];
        let value = Object.values(s)[0];
        if (p[key] && p[key].includes(id) && !p.isWorkerGroup) {
          return `group-user--${value}`;
        }
      }
    },
    openAddAbsencesModal() {
      if (this.activeContentTab === "hr") {
        this.isAbsencesModalOpen = true;
      }
    },
    closeAbsencesModal(update) {
      if (update) {
        this.fetchData();
      }
      this.isAbsencesModalOpen = false;
    },
    closeEditAbscenceModal(update) {
      if (update) {
        this.fetchData();
      }
      this.selectedAbsence = "";
    },
    closeCalendarObjectModal(update) {
      this.planGroup = null;
      this.newPlanning = false;
      this.selectedDate = undefined;
      if (update) this.fetchData();
    },
    closeCalendarGroupModal(update) {
      this.selectedPlanning = null;
      this.isCalendarGroupModalOpen = false;
      if (update) this.fetchData();
    },
    closeCalendarTransportModal(update) {
      this.selectedPlanning = null;
      this.isCalendarTransportModalOpen = false;
      if (update) this.fetchData();
    },
    handlePlansHover(g, v) {
      if (g.plannings && g.plannings.length) {
        setTimeout(() => {
          this.$set(g, "hovered", v);
        }, 100);
      }
    },
    handlePlansMouseEnter(g, d) {
      if (g && d) {
        if (this.isSelectingPlans && g.plannings.length) {
          // this.toggleGroupDay(g, d, this.selectedPlanDays);
        } else if (this.isSelectingDays && !g.plannings.length) {
          this.toggleGroupDay(g, d, this.selectedDays);
        }
      }
    },
    handleGroupPlansMouseEnter(g, d) {
      if (!this.isMobile) {
        if (this.basicView) this.handlePlansMouseEnter(g, d);
        else this.handlePlansHover(g, true);
      }
    },
    handleGroupPlansMouseLeave(g) {
      if (!this.isMobile) {
        this.handlePlansHover(g, false);
      }
    },
    groupContentClick(g, d) {
      if (this.isMobile && !this.basicView) {
        this.handlePlansHover(g, true);
      } else if (this.basicView) {
        this.addGroupPlans(g, d);
      }
    },
    addGroupPlans(g, d) {
      if (g.plannings.length) {
        // if (this.isSelectingPlans && Object.entries(this.selectedPlanDays).length) {
        //   this.isSelectingPlans = false;
        // } else {
        this.selectedPlanDays = {};
        this.isSelectingPlans = true;
        this.toggleGroupDay(g, d, this.selectedPlanDays);
        // }
      } else if (
        !g.plannings.length &&
        !this.isSelectingPlans &&
        Object.entries(this.selectedPlanDays).length
      ) {
        if (!this.isSelectingDays)
          (this.selectedDays = {}),
            (this.isSelectingDays = true),
            this.toggleGroupDay(g, d, this.selectedDays);
        else this.isSelectingDays = false;
      }
    },
    toggleGroupDay(g, d, array) {
      if (
        this.getUser.permissions.isSuperAdmin ||
        this.getUser.permissions.isAdmin
      ) {
        if (!array[d]) {
          this.$set(array, d, [g._id]);
        } else {
          const index = array[d].indexOf(g._id);
          if (index === -1) {
            this.$set(array[d], array[d].length, g._id);
          } else {
            this.$delete(array[d], index);
          }
        }
      }
    },
    // TODO: TRY TO BETTER THE "MOVE" LOGIC
    async handleSelectedDayPlans(action, movePlans) {
      const promises = [];
      const plans = [];

      for (let p of Object.entries(this.selectedPlanDays)) {
        let day = p[0];
        let groups = p[1];

        for (let g of this.groupsPlannings[
          new Date(day).toISOString().slice(0, 10)
        ]) {
          if (groups.includes(g._id)) {
            for (let p of g.plannings) {
              if (!plans.includes(p._id)) plans.push(p._id);
            }
          }
        }
      }

      if (action !== "delete") {
        for (let e of Object.entries(this.selectedDays)) {
          let day = e[0];
          let groups = e[1];

          for (let p of plans) {
            promises.push(
              await new Promise((resolve) => {
                const url = `${process.env.VUE_APP_BASE_URI}/planning/${p}/${action}`;

                let body = { groups: groups };
                if (action === "copy") body["dates"] = [day];
                // if (action === "move") body["date"] = [day];

                this.$http
                  .put(url, body)
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    console.log(error.response);
                    this.$snotify.error(this.$t("something-went-wrong"));
                  });
              })
            );
          }
        }
      }

      if (movePlans) {
        for (let e of Object.entries(this.selectedPlanDays)) {
          let groups = e[1];

          for (let g of groups) {
            for (let p of plans) {
              promises.push(
                await new Promise((resolve) => {
                  const url = `${process.env.VUE_APP_BASE_URI}/planning/delete-group/${p}/${g}`;

                  this.$http
                    .post(url)
                    .then(() => {
                      resolve();
                    })
                    .catch((error) => {
                      console.log(error.response);
                      this.$snotify.error(this.$t("something-went-wrong"));
                    });
                })
              );
            }
          }
        }
      }

      if (action === "delete") {
        if (
          confirm("Сигурнили сте че искате да изтриете избраното планиране?")
        ) {
          for (let p of plans) {
            promises.push(
              await new Promise((resolve) => {
                const url = `${process.env.VUE_APP_BASE_URI}/planning/${p}`;

                this.$http
                  .delete(url)
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    console.log(error.response);
                    this.$snotify.error(this.$t("something-went-wrong"));
                  });
              })
            );
          }
        }
      }

      if (promises.length) {
        Promise.all(promises)
          .then(() => {
            this.fetchData();
            let text = "изтрихте";
            if (action === "copy") {
              text = "копирахте";
              if (movePlans) text = "преместихте";
            }

            this.$snotify.success(`Успешно ${text} планирането`);
            this.resetCopyingPlans();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleKeyPress(e) {
      if (
        this.getUser.permissions.isSuperAdmin ||
        this.getUser.permissions.isAdmin
      ) {
        if (Object.entries(this.selectedPlanDays).length) {
          if (e.ctrlKey && e.keyCode === 67) {
            // CTRL + C
            this.isSelectingPlans = false;
            this.$snotify.success(
              "Копирано планиране. Изберете един или повече празни дни, за да го поставите"
            );
          }
          if (e.keyCode === 46) {
            this.handleSelectedDayPlans("delete");
          }
        }

        if (Object.entries(this.selectedDays).length) {
          if (e.ctrlKey && e.keyCode === 86) {
            // CTRL + V
            this.handleSelectedDayPlans("copy");
          } else if (e.ctrlKey && e.keyCode === 88) {
            // CTRL + X
            this.handleSelectedDayPlans("copy", true);
          }
        }
      }
    },
    resetCopyingPlans() {
      this.selectedPlanDays = {};
      this.selectedDays = {};
      this.isSelectingPlans = false;
      this.isSelectingDays = false;
    },
    handleCompanies(c) {
      const url = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/exists/${this.date.toISOString()}/${c.companyId}/${
        c.objectId
      }/${c.partId}`;
      this.$http.get(url).then((response) => {
        if (!response.data.length) {
          const calendar = {
            date: this.date,
            createdAt: new Date(),
            createdBy: this.getUser._id,
            companyId: c.companyId,
            objectId: c.objectId,
            partId: c.partId,
            isReady: false,
            isConfirmed: false,
          };
          const url = `${process.env.VUE_APP_BASE_URI}/calendar`;
          this.$http
            .post(url, calendar)
            .then((a) => {
              if (a.data.errors) {
                console.log(a.data.errors);
                this.$snotify.error(this.$t("something-went-wrong"));
              } else {
                const dateString = `${this.date.getDate()} ${
                  this.months[this.date.getMonth()]
                } ${this.date.getFullYear()}`;
                this.$snotify.success(
                  `${this.$t("successfully-added-site-for")} ${dateString}`
                );
                this.getCalendars();
                this.closeAddCompaniesModal();
                if (calendar.objectId) {
                  let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${calendar.objectId}`;
                  return this.$http
                    .get(url)
                    .then((response) => {
                      if (response.data) {
                        this.newLog(
                          "newCalendar",
                          `${this.$t("site").toLowerCase()} ${
                            response.data[0].objectName
                          } - ${this.$t("date")} ${dateString}`
                        );
                      }
                    })
                    .catch((error) => console.log(error));
                }
              }
            })
            .catch((error) => {
              console.log(error.response);
              this.$snotify.error(this.$t("something-went-wrong"));
            });
        } else {
          this.$snotify.error(
            `${this.$t("already-added-site-for")} ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
        }
      });
    },
    openCalendarGroupModal(p) {
      this.selectedPlanning = p;
      this.isCalendarGroupModalOpen = true;
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorkers(workers) {
      const workersArray = [];

      workers.forEach((w) => {
        workersArray.push({
          _id: w._id,
        });
      });

      const newCalendar = this.calendars[this.selectedObject];
      newCalendar.workers = workersArray;

      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${newCalendar._id}`;

      this.$http
        .put(url, newCalendar)
        .then((a) => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(this.$t("something-went-wrong"));
          } else {
            this.$snotify.success(this.$t("successfully-updated-workers"));
            this.getCalendars();
            this.closeAddWorkersModal();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    togglePlanningFilter(v) {
      if (this.activeContentTab === "object" && v === "showWorkerGroups")
        return false;
      if (this.planningFilters[v]) Vue.delete(this.planningFilters, v);
      else this.$set(this.planningFilters, v, true);

      if (v !== "showGroupUsers" && v !== "showPlannedGroupsFirst")
      // this.getPlannings();
        this.fetchData();
      if (
        v === "showOnlyUnReported" &&
        this.planningFilters["showOnlyUnReported"]
      ) {
        this.$set(this.planningFilters, "showGroupUsers", true);
      }
      this.getGroups();
    },
    openTransport(p) {
      this.selectedPlanning = p;
      this.isCalendarTransportModalOpen = true;
    },
    // openMaterials(index, isReady) {
    openMaterials(p) {
      this.selectedPlanning = p;
      this.selectedPlanning.addTo = "materials";
      this.getMaterials();
      this.isAddMaterialsModalOpened = true;
    },
    getMaterials() {
      let p = this.selectedPlanning;
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/materials/${p.company._id}/${p.object._id}`;
      return this.$http
        .get(url)
        .then((res) => {
          this.selectedObjectMaterials = res.data;
        })
        .catch((error) => console.log(error));
    },
    handleMaterial(m) {
      this.addQuantityTo = m[0];
    },
    closeAddMaterialsModal() {
      // this.resetSelectedIds();
      this.selectedObjectMaterials = [];
      this.isAddMaterialsModalOpened = false;
    },
    openMechanizations(index, isReady) {
      if (!isReady) {
        this.selectedIds = {
          companyId: this.calendars[index].company._id,
          objectId: this.calendars[index].object._id,
          partId: this.calendars[index].part._id,
          partIndex: index,
          type: "mechanizations",
        };
        this.isAddMechanizationsModalOpened = true;
        this.getMechanizations();
      } else {
        this.$snotify.error(
          this.$t("already-sent-for-confirmation-mechanizations")
        );
      }
    },
    getMechanizations() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/part/${this.selectedIds.objectId}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedObjectMechanizations = response.data[0].mechanizations;
        })
        .catch((error) => console.log(error));
    },
    handleMechanization(m) {
      this.addQuantityTo = m;
    },
    closeAddMechanizationsModal() {
      this.resetSelectedIds();
      this.selectedObjectMechanizations = [];
      this.isAddMechanizationsModalOpened = false;
    },
    resetSelectedIds() {
      this.selectedIds = {
        companyId: null,
        objectId: null,
        partId: null,
        partIndex: null,
        type: null,
      };
    },
    updatePlan(p) {
      const url = `${process.env.VUE_APP_BASE_URI}/planning/${p._id}`;
      this.$http
        .put(url, p)
        .then((a) => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(this.$t("something-went-wrong"));
          } else {
            this.fetchData();
            this.closeAddQuantityModal();
            this.selectedPlanning = null;
            this.closeAddMaterialsModal();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    handleUpdate(x) {
      this.selectedPlanning[this.selectedPlanning.addTo].push(x.value);
      // const url = `${process.env.VUE_APP_BASE_URI}/planning/${this.selectedPlanning._id}`;
      this.updatePlan(this.selectedPlanning);
    },
    closeAddQuantityModal() {
      this.addQuantityTo = null;
    },
    getCalendars() {
      this.$store.dispatch("startLoading");

      let type = "";

      // DAILY
      let firstDate = this.date;
      let secondDate = this.date;
      // WHOLE WEEK
      if (this.activePeriodTab === "week") {
        firstDate = new Date(this.date).GetFirstDayOfWeek();
        secondDate = new Date(this.date).GetLastDayOfWeek();
      }

      type = "day";

      let requestUrl = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/${type}/${this.date.toISOString()}`;

      // BUILD THE REQUEST URL FOR ALL CALENDARS
      if (this.activePeriodTab === "week") {
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}`;
      }
      // WEEK
      else if (this.activePeriodTab === "week") {
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
      }

      this.$http
        .get(requestUrl)
        .then((response) => {
          this.$store.dispatch("stopLoading");
          this.calendars = response.data;
        })
        .catch((error) => console.log(error));
    },
    openCopyMoveCalendarModal(type, c) {
      this.CopyMoveCalendarModalAction = type;
      this.CopyMoveCalendarModalCalendar = c;
    },
    closeCopyMoveCalendarModal(update) {
      this.CopyMoveCalendarModalAction = "";
      this.CopyMoveCalendarModalCalendar = undefined;
      if (update) this.fetchData();
    },
    removeCalendar(c) {
      if (c._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}`;
        this.$http
          .delete(url)
          .then((result) => {
            if (result.data.errors) {
              this.$snotify.error(this.$t("something-went-wrong"));
              console.log(result);
            } else {
              this.$snotify.success(this.$t("successfully-deleted"));
              this.getCalendars();
              if (result.data.calendar.objectId) {
                let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${result.data.calendar.objectId}`;
                return this.$http
                  .get(url)
                  .then((response) => {
                    if (response.data) {
                      let dateString = new Date(result.data.calendar.date);
                      dateString = `${dateString.getDate()} ${
                        this.months[dateString.getMonth()]
                      } ${dateString.getFullYear()}`;
                      this.newLog(
                        "deleteCalendar",
                        `${this.$t("site").toLowerCase()} ${
                          response.data[0].objectName
                        } - ${this.$t("date")} ${dateString}`
                      );
                    }
                  })
                  .catch((error) => console.log(error));
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.$snotify.error(this.$t("something-went-wrong"));
          });
      }
    },
    removeGroupFromPlan(g, p) {
      const msg = "Сигурни ли сте, че искате да изтриете групата от тази част?";
      if (!confirm(msg)) return;

      let url = `${process.env.VUE_APP_BASE_URI}/planning/delete-group/${p._id}/${g._id}`;
      this.$http
        .post(url)
        .then((result) => {
          console.log(result);
          this.$snotify.success(this.$t("successfully-deleted"));
          this.fetchData();
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    editPlanning(p) {
      const msg = "Сигурни ли сте, че искате да редактирате планирането?";
      if (!confirm(msg)) return;

      if (p._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/planning/${p._id}/toggle-edit`;
        this.$http
          .put(url)
          .then(() => {
            this.$snotify.success(this.$t("Режим на редакция е активиран"));
            this.fetchData();
          })
          .catch((error) => {
            console.log(error);
            this.$snotify.error(this.$t("something-went-wrong"));
          });
      }
    },
    removePlanning(p) {
      const msg = "Сигурни ли сте, че искате да изтриете планирането?";
      if (!confirm(msg)) return;

      if (p._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/planning/${p._id}`;
        this.$http
          .delete(url)
          .then((result) => {
            console.log(result);
            this.$snotify.success(this.$t("successfully-deleted"));
            this.fetchData();
          })
          .catch((error) => {
            console.log(error);
            this.$snotify.error(this.$t("something-went-wrong"));
          });
      }
    },
    // Close the workers modal
    closeAddCompaniesModal() {
      this.isAddCompaniesModalOpened = false;
    },
    closeAddWorkersModal() {
      this.selectedObject = undefined;
    },
    print() {
      this.$snotify.warning(this.$t("under-construction"));
    },
    getInfo(c, short) {
      let output = `${this.$t("created-at")} ${
        short
          ? this.$options.filters.formatDate(c.createdAt)
          : this.$options.filters.formatFullDate(c.createdAt)
      } ${this.$t("by")} ${c.createdBy.name}${
        short ? "" : ` (${c.createdBy.username})`
      }.`;

      if (c.isReady) {
        output += ` ${this.$t("sent-for-confirmation-at")} ${
          short
            ? this.$options.filters.formatDate(c.readyAt)
            : this.$options.filters.formatFullDate(c.readyAt)
        } ${this.$t("by")} ${c.readyBy.name}${
          short ? "" : ` (${c.readyBy.username})`
        }.`;
      }

      if (c.isConfirmed) {
        output += ` ${this.$t("approved-at")} ${
          short
            ? this.$options.filters.formatDate(c.confirmedAt)
            : this.$options.filters.formatFullDate(c.confirmedAt)
        } ${this.$t("by")} ${c.confirmedBy.name}${
          short ? "" : ` (${c.confirmedBy.username})`
        }.`;
      }

      return output;
    },
    displayInfo(c) {
      this.$snotify.info(this.getInfo(c, true));
    },
    openCreateReport(p) {
      // const today = new Date();
      // today.setHours(23, 59, 59, 59);

      // let workerGroups = p.groups
      //   .filter((g) => g.isWorkerGroup)
      //   .map((t) => t._id);
      // let groups = p.groups.filter((g) => !g.isWorkerGroup);
      // let users = p.users;

      // let content = {};
      // content.date = p.date;
      // content.company = p.company;
      // content.object = p.object;
      // content.part = p.part;
      // content.users = users;
      // content.groups = groups;
      // content.workerGroups = workerGroups;
      // content.materials = p.materials;
      // content.planning = p._id;
      // content = JSON.stringify(content);

      // window.open(`/reports/new?content=${content}`, "_blank");
      window.open(`/reports/new?planId=${p._id}`, "_blank");
    },
    proceedToNextStep(p, action) {
      const msgs = {
        "for-confirmation": "изпратите планирането за потвърждение?",
        "deletion-request": "изпратите заявка за изтриване на планирането?",
        "reject-deletion-request": "откажете заявката за изтриване?",
        reject: "откажете заявката за одобрение?",
        confirm: "потвърдите заявката за одобрение?",
        "reject-edit":
          "откажете заявката за одобрение на редактирано планиране?",
        "confirm-edit":
          "потвърдите заявката за одобрение на редактирано планиране?",
        // report:
        //   "създадете отчет от планирането? Всички други действия (освен копиране) ще станат недостъпни за него.",
      };

      if (action !== "confirm") {
        if (!confirm("Сигурни ли сте, че искате да " + msgs[action])) return;
      }

      if (action !== "deletion-request") {
        if (
          !p.groups.length &&
          !p.users.length &&
          !p.transport.length &&
          !p.materials.length
        ) {
          return this.$snotify.error(
            "Трябва да добавите поне една група, служител, материал или транспорт."
          );
        }
      }

      const url = `${process.env.VUE_APP_BASE_URI}/planning/${p._id}/${action}`;
      this.$http
        .put(url)
        .then((res) => {
          if (res.data.exists ? res.data.exists.length : false) {
            for (let i = 0; i < res.data.exists.length; i++) {
              this.$snotify.error(
                `${res.data.exists[i].workers.name} е вече добавен към друг отчет в диапазона ${res.data.exists[i].workers.startHour} - ${res.data.exists[i].workers.endHour}`
              );
            }
          } else if (
            res.data.existsAbsences ? res.data.existsAbsences.length : false
          ) {
            for (let a of res.data.existsAbsences) {
              let formatFrom = format(new Date(a.from), 'dd/MM/yyyy');
              let formatTo = format(new Date(a.to), 'dd/MM/yyyy');

              this.$snotify.error(
                `${a.user.name} е в отпуск за датите ${formatFrom} - ${formatTo}`
              );
            }
          }

          this.fetchData();
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    sendConfirm(c) {
      if (c.isReady) {
        if (confirm(this.$t("confirm-confirmation"))) {
          const newCalendar = c;
          newCalendar.isConfirmed = true;
          newCalendar.confirmedBy = this.getUser._id;
          newCalendar.confirmedAt = new Date();

          this.updateCalendar(
            newCalendar,
            this.$t("request-confirmed"),
            "confirmCalendar"
          );
        }
      }
    },
    updateCalendar(c, message, log) {
      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}`;
      this.$http
        .put(url, c)
        .then((a) => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(this.$t("something-went-wrong"));
          } else {
            this.$snotify.success(message);
            const dateString = `${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`;
            this.newLog(
              log,
              `${this.$t("site").toLowerCase()} ${
                c.object.objectName
              } - ${this.$t("date")} ${dateString}`
            );
            this.getCalendars();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    ownOrSuperAdmin(p) {
      return p._id && p.createdBy
        ? p.createdBy.indexOf(this.getUser._id) > -1 ||
            this.getUser.permissions.isSuperAdmin
        : false;
    },
    ownOrSuperAdminOrIsReporter(p) {
      let isPartReporter = false;
      if (p.reporters && p.reporters.length)
        isPartReporter = p.reporters.filter(
          (pr) => pr._id === this.getUser._id
        ).length;

      return p._id && p.createdBy
        ? p.createdBy.indexOf(this.getUser._id) > -1 ||
            this.getUser.permissions.isSuperAdmin ||
            isPartReporter
        : false;
    },
    toggleExport(e) {
      if (!this.allowExport) {
        e.preventDefault();
        this.$snotify.warning(
          "За избрания месец няма създадени отчети или отсъствия"
        );
      }
    },
    getHighlighted() {
      const type = this.activeContentTab === "hr" ? "absence" : "planning";
      const requestUrl = `${process.env.VUE_APP_BASE_URI}/${type}/highlighted/${this.date}`;
      this.highlightedDates = [];

      this.$http
        .get(requestUrl)
        .then((response) => {
          if (response.data ? response.data.dates : false) {
            response.data.dates.map((d) => {
              this.highlightedDates.push(new Date(d));
            });
            if (this.activePeriodTab === "week") {
              this.highlighted = {
                from: this.firstDay,
                to: this.lastDay,
                additional: this.highlightedDates,
              };
            } else {
              this.highlighted = {
                additional: this.highlightedDates,
              };
            }
          }
        })
        .catch((error) => console.log(error));
    },
    scrollH(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById("rightPanel").scrollLeft -= delta * 40;
      e.preventDefault();
    },
    isMobileMode() {
      if (window.innerWidth < 1510) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
        this.isLeftPanelOpen = false;
        this.isPlanningFiltersOpen = false;
      }
    },
    closePanel(e) {
      this.$nextTick(() => {
        if (!e.target.classList.contains("left-panel-toggle")) {
          if (this.isLeftPanelOpen) {
            this.isLeftPanelOpen = false;
          }
        }
      });
    },
    closeFilters() {
      this.isPlanningFiltersOpen = false;
    },
  },
  mounted() {
    const todayCell = document.getElementsByClassName("today")[0];
    if (todayCell) {
      todayCell.click();
    } else {
      this.date = new Date();
    }

    this.getCalendars();
    // this.fetchData();
    this.getHighlighted();

    if (this.$route.query.plan === "true") {
      this.isAddCompaniesModalOpened = true;
    }

    this.$on("mousewheel", this.scrollH, false);
    // Start listening for children's events
    this.$on("saveAddCompaniesModal", this.handleCompanies);
    this.$on("saveAddUsersModal", this.handleWorkers);
    this.$on("saveAddMaterialsModal", this.handleMaterial);
    this.$on("saveAddMechanizationsModal", this.handleMechanization);
    this.$on("getMechanizationsAgain", this.getMechanizations);
    this.$on("addQuantity", this.handleUpdate);
    // Close listening for children's events
    this.$on("closeAddCompaniesModal", this.closeAddCompaniesModal);
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddMechanizationsModal", this.closeAddMechanizationsModal);
    this.$on("closeAddQuantityModal", this.closeAddQuantityModal);
    this.isMobileMode();
    window.addEventListener("resize", this.isMobileMode);
    window.addEventListener("keydown", this.handleKeyPress);
  },
  destroyed() {
    // Stop listening
    this.$off("mousewheel");
    this.$off("saveAddCompaniesModal");
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddMechanizationsModal");
    this.$off("addQuantity");
    this.$off("getMechanizationsAgain");
    this.$off("closeAddCompaniesModal");
    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddMechanizationsModal");
    this.$off("closeAddQuantityModal");
    window.removeEventListener("resize", this.isMobileMode);
    window.removeEventListener("keydown", this.handleKeyPress);
  },
};
</script>

<style lang="scss">
/* IT WILL BE A GOOD IDEA TO REFACTOR THE WHOLE CSS  */
.calendar-wrapper {
  display: flex;

  label {
    color: #373737;
    font-size: 11px;
    font-weight: 700;
  }
  .week {
    background-color: #f0f0f7;
    border: 0;
    text-align: center;
    width: 300px;
  }
  .calendar {
    background-color: #f0f0f7;
    padding: 10px;
    transition: all 0.3s;
    width: 100%;

    &.calendar--fullscreen {
      position: fixed;
      top: 0;
      left: 0;

      .calendar-header {
        position: absolute;
        right: 5px;
        z-index: 5;
      }

      .calendar-content {
        height: calc(100vh - 30px);
      }
    }
  }
  .calendar-header {
    align-items: center;
    display: flex;
    height: 36px;
    justify-content: space-between;
  }
  .title-and-date {
    align-items: center;
    display: flex;
    height: 100%;
    font-weight: 700;
    gap: 10px;

    .tms {
      color: #374e85;
      display: none;
      font-size: 30px;
      transition: all 0.3s;

      &.tms--active {
        color: #840e0e;
        transform: scaleX(-1);
      }
    }
    .icon-and-text {
      align-items: center;
      display: flex;
      gap: 5px;
    }
  }
  .calendar-header h2 {
    align-items: center;
    border-right: 1px solid #7a9fb8;
    color: #373737;
    display: flex;
    font-weight: 700;
    height: 100%;
    padding-right: 10px;
  }
  .calendar-header-left {
    align-items: center;
    display: flex;
    gap: 5px;
    justify-content: space-between;
    /* width: 300px; */
  }
  .calendar-header-left .filters {
    background: rgba(122, 159, 184, 0.2);
    border: 1px solid #7a9fb8;
    border-radius: 4px;
    display: flex;
    gap: 5px;
    padding: 7px;

    .checkbox {
      .label {
        max-width: 130px;
        white-space: pre-wrap;
      }
    }
  }
  .calendar-header-left .filters .option:hover {
    background: initial;
  }
  .calendar-header-left label {
    margin-right: 10px;
    white-space: nowrap;
  }
  .calendar-content {
    background-color: #fff;
    border: 1px solid #c0cce2;
    border-radius: 4px;
    display: flex;
    height: calc(100vh - 150px);
    overflow: hidden;
    margin-top: 10px;
    min-height: calc(100vh - 166px);
    /* max-height: calc(100vh - 166px); */
    /* padding: 12px 15px; */
  }
  .left-panel-wrapper {
    overflow: hidden;
    min-width: 220px;
    width: 220px;
  }
  .left-panel {
    background-color: #f2f6f9;
    border-right: 1px solid #c0cce2;
    display: flex;
    flex-direction: column;
    /* margin-right: 10px; */
    /* padding-right: 10px; */
    overflow: auto;
    height: 100%;
    width: 100%;
  }
  .left-panel-header {
    align-items: center;
    display: flex;
    flex-direction: column;
    /* height: 45px; */
    justify-content: space-between;
    // min-height: 45px;
    min-height: fit-content;
    padding-bottom: 10px;
    padding-right: 10px;
  }
  .left-panel-header .views {
    width: 100%;
  }
  .views {
    display: flex;
    justify-content: center;
  }
  .view {
    /* background-color: #f5f5f5; */
    background-color: transparent;
    border: 1px solid transparent;
    color: #373737;
    cursor: pointer;
    font-size: 13px;
    height: 35px;
    line-height: 13px;
    min-width: 80px;
    text-align: center;
    transition: all 0.3s;
    width: 100%;
  }
  .view--active {
    background-color: #7a9fb8;
    color: #ffffff;
  }
  .view:hover {
    opacity: 0.8;
  }

  .calendar-header-left .views {
    border: 1px solid #7a9fb8;
    border-radius: 4px;
  }
  .calendar-header-left .views .view {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0 1rem;
  }
  .calendar-header-left .views .view:not(:last-child) {
    border-right: 1px solid #7a9fb8;
  }
  .left-panel-header .views {
    flex-direction: column;
  }
  .left-panel-header .views .view {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 0 21px;
    text-align: left;
  }
  .left-panel-header .views p {
    color: #7a9fb8;
    font-size: 10px;
    padding: 8px 12px;
  }
  .stages-legend {
    padding: 20px 10px;
    img {
      object-fit: cover;
      width: 100%;
    }
  }
  .datepicker-legend {
    border-bottom: 1px solid #c0cce2;
    padding: 0 21px 5px;
  }
  .datepicker-legend div {
    align-items: center;
    display: flex;
    gap: 13px;
  }
  .datepicker-legend span {
    align-items: center;
    border-radius: 50%;
    display: flex;
    font-size: 12px;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
  .datepicker-legend p {
    font-size: 10px;
  }

  .datepicker-legend div:first-child span {
    text-decoration: underline;
    font-weight: 700;
  }
  .datepicker-legend div:nth-child(2) span {
    background: #c0cce2;
  }
  .datepicker-legend div:nth-child(3) span {
    border: 1px solid #7a9fb8;
    margin-top: 5px;
  }

  /* .view--active:hover {
  background-color: rgb(122, 159, 184, 0.8);
} */
  .new-content-data-item {
    border: 1px solid #f4eaea;
    height: 100%;
    overflow: auto;
    position: relative;
    /* max-height: 50vh; */
    width: 100%;
  }
  .new-content-data-item-toggle {
    background-color: #cecece;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    font-size: 11px;
    height: 36px;
    min-height: 36px;
    margin-top: 10px;
    width: 100%;
    -webkit-transition: none;
    -moz-transition: none;
    -ms-transition: none;
    -o-transition: none;
    transition: none;
    z-index: 1;
  }
  .new-content-data-item-toggle:hover {
    background-color: #cecece;
  }
  .new-content-data-item-toggle .new-content-data-item-toggle-circle {
    position: absolute;
    right: 10px;
    top: 6px;
  }
  .add-wrapper {
    width: 100%;
  }
  .add {
    align-items: center;
    background-color: #3b86ff;
    border: 0;
    border-radius: 4px;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    font-size: 11px;
    height: 50px;
    justify-content: space-between;
    /* font-weight: 700; */
    padding: 0 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .add:hover {
    background-color: #5193fd;
  }
  .add-wrapper span.new-content-data-item-toggle-circle {
    background-color: #ffffff;
    font-size: 16px;
    color: #0078d7;
  }
  .add-wrapper .new-content-data-item-toggle-circle .tms2 {
    background-color: #ffffff;
    border-color: #ffffff;
  }
  .add-wrapper:hover .new-content-data-item-toggle-circle .tms2 {
    border-color: #3b86ff;
  }
  .right-panel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
  }
  .selected-date {
    font-size: 18px;
    padding: 7px 0;
  }
  .overtime {
    background-color: rgba(252, 252, 229, 0.63);
    border: 1px solid #eaf0f4;
    transform: rotate(270deg);
  }
  .normal {
    background-color: rgba(232, 245, 233, 0.37);
    border: 1px solid #eaf0f4;
    transform: rotate(270deg);
  }
  /* WORKERS */
  .workers-calendar,
  .objects-calendar,
  .big-calendar {
    display: flex;
    height: 100%;
  }
  .workers-calendar-item,
  .objects-calendar-item,
  .big-calendar-item {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    min-width: 400px;
    width: 400px;
  }
  .workers-calendar-item-header,
  .objects-calendar-item-header,
  .date-calendar-item-header {
    align-items: center;
    background-color: #cecece;
    border: 1px solid #f4eaea;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 6px;
    max-height: 65px;
    min-height: 65px;
    padding: 10px 0;
    position: relative;
    width: 100%;
  }
  .workers-calendar-item-header {
    max-height: 35px;
    min-height: 35px;
  }
  .workers-calendar-item-header p,
  .objects-calendar-item-header p,
  .date-calendar-item-header p {
    color: #0058bc;
    font-size: 9px;
    font-weight: 400;
    text-align: center;
  }
  .workers-calendar-item-header p:nth-child(3),
  .objects-calendar-item-header p:nth-child(3),
  .date-calendar-item-header p:nth-child(3) {
    font-size: 12px;
    font-weight: 700;
  }
  .workers-calendar-item-content,
  .objects-calendar-item-content,
  .big-calendar-item-content {
    align-items: center;
    background-color: #fff;
    border: 1px solid #f4eaea;
    border-radius: 4px;
    flex-direction: column;
    display: flex;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    padding: 5px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    position: relative;
    width: 400px;
  }
  /* .workers-calendar-item-content:hover,
.objects-calendar-item-content:hover,
.big-calendar-item-content:hover {
  background-color: #fff;
} */
  .new-content-data-item-content {
    display: flex;
    flex-direction: column;
  }
  .new-content-data-item-content-no-results {
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .new-content-data-item-content p {
    color: #737373;
    font-size: 11px;
    padding: 5px;
  }
  .add-items-wrapper {
    display: flex;
    align-items: center;
  }
  .add-items-wrapper:last-child {
    width: 100%;
  }
  .workers-calendar-item-content-add,
  .objects-calendar-item-content-add,
  .big-calendar-item-content-add {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 40px;
    /* padding: 4px; */
    width: 100%;
  }

  .objects-calendar-item-content-add-item {
    align-items: center;
    background-color: rgba(121, 119, 116, 0.15);
    border-radius: 4px;
    border: 1px solid transparent;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    height: 40px;
    margin-right: 7px;
    justify-content: center;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 40px;
  }
  .add-items-wrapper:last-child .objects-calendar-item-content-add-item {
    border: none;
    color: #fff;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 0;
    padding: 0 6px;
    width: 100%;
  }
  .add-items-wrapper:last-child .objects-calendar-item-content-add-item:hover {
    border: none;
    opacity: 0.8;
  }
  .button-send {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#6191d8+0,066894+100 */
    background: rgb(97, 145, 216); /* Old browsers */
    background: -moz-linear-gradient(
      top,
      rgba(97, 145, 216, 1) 0%,
      rgba(6, 104, 148, 1) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      top,
      rgba(97, 145, 216, 1) 0%,
      rgba(6, 104, 148, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to bottom,
      rgba(97, 145, 216, 1) 0%,
      rgba(6, 104, 148, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6191d8', endColorstr='#066894',GradientType=0 ); /* IE6-9 */
  }
  .add-items-wrapper:last-child
    .objects-calendar-item-content-add-item.button-wait,
  .add-items-wrapper:last-child
    .objects-calendar-item-content-add-item.button-wait:hover {
    background-color: #fdeada;
    cursor: default;
    justify-content: center;
    opacity: 1;
  }
  .button-wait span {
    color: #0058bc;
  }
  .add-items-wrapper:last-child
    .objects-calendar-item-content-add-item.button-confirmed,
  .add-items-wrapper:last-child
    .objects-calendar-item-content-add-item.button-confirmed:hover {
    background-color: #e2efd9;
    cursor: default;
    justify-content: center;
    opacity: 1;
  }
  .button-confirmed span {
    color: #055514;
  }
  .button-ok {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#068d33+0,3c4a00+100 */
    background: rgb(6, 141, 51); /* Old browsers */
    background: -moz-linear-gradient(
      top,
      rgba(6, 141, 51, 1) 0%,
      rgba(60, 74, 0, 1) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      top,
      rgba(6, 141, 51, 1) 0%,
      rgba(60, 74, 0, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to bottom,
      rgba(6, 141, 51, 1) 0%,
      rgba(60, 74, 0, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#068d33', endColorstr='#3c4a00',GradientType=0 ); /* IE6-9 */
  }
  .objects-calendar-item-content-add-item:disabled {
    cursor: default;
    opacity: 0.5;
  }
  /* .objects-calendar-item-content-add-item:last-child {
  margin-right: 0;
} */
  .objects-calendar-item-content-add-item-big {
    height: 100%;
    width: 100%;
  }
  .objects-calendar-item-content-add-item:hover:not(:disabled) {
    background-color: #fff;
    border-color: #cecece;
  }
  .objects-calendar-item-content-add-item-big:hover {
    background: rgba(237, 241, 245, 0.8);
  }
  .workers-calendar-item-content-add-item .tms,
  .workers-calendar-item-content-add-item .tms2,
  .objects-calendar-item-content-add-item .tms,
  .objects-calendar-item-content-add-item .tms2,
  .big-calendar-item-content-add-item .tms,
  .big-calendar-item-content-add-item .tms2 {
    align-items: center;
    border-radius: 50%;
    color: #fff;
    display: flex;
    font-size: 16px;
    flex-direction: column;
    height: 34px;
    justify-content: center;
    position: relative;
    width: 34px;
  }
  .workers-calendar-item-content-add-item .tms::after,
  .workers-calendar-item-content-add-item .tms2::after,
  .objects-calendar-item-content-add-item .tms::after,
  .objects-calendar-item-content-add-item .tms2::after,
  .big-calendar-item-content-add-item .tms::after,
  .big-calendar-item-content-add-item .tms2::after {
    content: "";
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 50%;
    height: 30px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 30px;
  }
  .workers-calendar-item-content:hover
    .workers-calendar-item-content-add-hidden,
  .big-calendar-item-content:hover .big-calendar-item-content-add-hidden {
    background-color: rgba(237, 241, 245, 0.8);
    opacity: 1;
  }
  .workers-calendar-item-content-add-item:hover .tms::after,
  .workers-calendar-item-content-add-item:hover .tms2::after,
  .objects-calendar-item-content-add-item:hover .tms::after,
  .objects-calendar-item-content-add-item:hover .tms2::after,
  .big-calendar-item-content-add-item:hover .tms::after,
  .big-calendar-item-content-add-item:hover .tms2::after {
    border: 1px solid #fff;
  }
  .workers-calendar-item-content-add p,
  .objects-calendar-item-content-add p,
  .big-calendar-item-content-add p {
    font-size: 10px;
    text-align: center;
  }
  .no-results-calendar {
    width: 100%;
  }
  .no-results-calendar .workers-calendar-item {
    width: 100%;
  }
  .no-results-calendar .workers-calendar-item-content {
    background: #fff;
    cursor: default;
    width: 100%;
  }
  /* .no-results-calendar .workers-calendar-item-content:hover {
  background-color: transparent;
} */
  .companies-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    justify-content: center;
    width: 100%;
  }
  .companies-tag,
  .personal-tag {
    align-items: center;
    background-color: #cecece;
    display: flex;
    border-radius: 4px;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 5px;
    margin-bottom: 5px;
    min-height: 180px;
    width: 100%;
  }
  .companies-tag-send {
    background-color: #dbe5f1;
  }
  .companies-tag-wait {
    background-color: #fdeada;
  }
  .companies-tag-ok {
    background-color: #e2efd9;
  }
  .personal-tag {
    background-color: #bbdefb;
  }
  .companies-tag:last-child,
  .personal-tag:last-child {
    margin-bottom: 0;
  }
  .companies-tag p,
  .personal-tag p {
    font-size: 10px;
    line-height: 12px;
    opacity: 0.5;
    margin: 3px 0;
    text-align: center;
  }
  .companies-tag p:nth-child(3),
  .personal-tag p:nth-child(3) {
    font-size: 16px;
    line-height: 20px;
    margin: 5px 0 0;
    text-align: center;
    opacity: 1;
  }
  .list-container,
  .big-toggle-wrapper {
    background-color: #cecece;
    border: 1px solid #f4eaea;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 33.33%;
    max-height: 25vh;
    margin-bottom: 4px;
    padding-bottom: 10px;
    position: relative;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    /* justify-content: center; */
    width: 100%;
  }
  .big-toggle-wrapper {
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: default;
    flex-direction: row;
    justify-content: center;
    position: relative;
    padding: 0;
  }
  /* .list-container:hover {
  background-color: rgba(255, 255, 255, 0.8);
} */
  /* .big-toggle-workers {
  align-items: flex-end;
  padding-bottom: 10px;
} */
  .big-toggle-mechanizations {
    align-items: flex-start;
    padding-top: 10px;
  }
  .big-toggle {
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
    height: 124px;
    border: 1px dashed #e0d0c1;
    padding: 3px;
    width: 124px;
  }
  .big-toggle-inner {
    background-color: #cecece;
    border-radius: 50%;
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }

  .big-toggle-workers .big-toggle-inner {
    background-color: #d9ecd8;
  }

  .big-toggle-workers .big-toggle:hover .big-toggle-inner {
    background-color: #9cd299;
  }

  .big-toggle-materials .big-toggle-inner {
    background-color: #d8ddec;
  }
  .big-toggle-materials .big-toggle:hover .big-toggle-inner {
    background-color: #9cabd6;
  }

  .big-toggle-mechanizations .big-toggle-inner {
    background-color: #ecddd8;
  }

  .big-toggle-mechanizations .big-toggle:hover .big-toggle-inner {
    background-color: #dcbbb0;
  }

  .big-toggle-inner .tms,
  .big-toggle-inner .tms2 {
    align-items: center;
    background-color: #fff;
    border-radius: 50%;
    color: #0058bc;
    display: flex;
    font-size: 16px;
    height: 32px;
    justify-content: center;
    margin-bottom: 6px;
    width: 32px;
  }
  .big-toggle-inner p {
    color: #000;
    font-size: 11px;
    font-weight: 700;
    line-height: 12px;
    text-align: center;
  }
  .list-container header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
  }
  .list-container header p {
    color: #0058bc;
    font-size: 12px;
    font-weight: 700;
  }
  .list-container .toggle {
    align-items: center;
    background-color: #0058bc;
    border-radius: 50%;
    color: #fff;
    font-size: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 34px;
    justify-content: center;
    position: absolute;
    right: 5px;
    top: 5px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 34px;
  }
  .list-tag-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }
  .list-tag-wrapper::-webkit-scrollbar {
    width: 1px;
  }

  .list-tag-wrapper::-webkit-scrollbar-track {
    background: #ddd;
  }

  .list-tag-wrapper::-webkit-scrollbar-thumb {
    background: #0058bc;
  }

  .list-tag {
    align-items: center;
    color: #0058bc;
    font-size: 10px;
    display: flex;
    /* margin: 2px 0; */
    padding: 5px 10px;
    /* justify-content: center; */
    width: 100%;
  }
  .delete-item {
    cursor: pointer;
    color: #d58080;
    font-size: 15px;
    margin-right: 4px;
    transition: all 0.3s;
  }
  .delete-item:hover {
    opacity: 0.7 !important;
  }
  .date-calendar-item-header .date-calendar-objects-count {
    align-items: center;
    background-color: #0058bc;
    border-radius: 15px;
    color: #fff;
    opacity: 1;
    font-weight: 400;
    display: flex;
    justify-content: center;
    margin-top: 5px;
    padding: 7px;
    width: 90%;
  }
  .date-calendar-item-header .date-calendar-objects-count .tms2 {
    font-size: 14px;
    font-weight: 400;
    margin-right: 5px;
  }
  .big-calendar-count-toggle {
    align-items: center;
    background-color: #104d80;
    border-radius: 30px;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 10px;
    position: relative;
    padding: 5px 10px;
  }
  .big-calendar-count-toggle span {
    font-size: 14px;
  }
  .big-calendar-count-toggle .tms2 {
    font-size: 20px;
    margin-right: 5px;
  }
  .company {
    align-items: start;
    padding: 4px;
  }
  .btn {
    margin: 0;
  }
  .btns {
    display: flex;
  }
  .btn--help {
    background-color: #5690c9;
    margin-left: 5px;
    width: 30px;
  }
  .btn--help:hover {
    background-color: #6c9fd3;
  }
  /* ABSENCES */
  .absences-wrapper {
    background-color: #fff;
    border: 1px solid #f4eaea;
    height: 100%;
    padding: 0 5px;
    width: 100%;
  }
  .absence-row {
    cursor: pointer;
    margin: 5px 0;
    transition: all 0.3s;
  }
  // .absence-row:hover {
  //   opacity: 0.6;
  // }
  // .absence-type {
  //   align-items: center;
  //   border-radius: 4px;
  //   display: inline-flex;
  //   font-size: 12px;
  //   font-weight: 500;
  //   height: 22px;
  //   justify-content: center;
  //   line-height: 12px;
  //   width: 170px;
  // }
  // .absence-type--paid {
  //   background-color: #e1bee7;
  //   color: #4a148c;
  // }
  // .absence-type--unpaid {
  //   background-color: #cfd8dc;
  //   color: #263238;
  // }
  // .absence-type--illness {
  //   background-color: #bbdefb;
  //   color: #0d47a1;
  // }
  // .absence-type--compensation {
  //   background-color: #b2dfdb;
  //   color: #004d40;
  // }
  // .absence-type--unreported {
  //   background-color: #d98a8a;
  //   color: #850606;
  // }
  .abscence-name {
    display: inline-block;
    margin: 0 20px;
  }
  .no-results-calendar-p {
    align-items: center;
    display: flex;
    font-size: 20px;
    font-weight: 600;
    height: 100%;
    justify-content: center;
    text-align: center;
  }
  .absences-wrapper .add-row {
    background: #f2f6f9 0% 0% no-repeat padding-box;
    border: 1px solid #c0cce2;
    border-radius: 4px;
    padding: 15px 10px;
    margin-top: 0;
    width: 100%;
  }
  /* OK */
  .objects-calendar-item-send .objects-calendar-item-header {
    background-color: #b8cce4;
  }
  .objects-calendar-item-send .list-container {
    background-color: #dbe5f1;
  }
  .objects-calendar-item-send .objects-calendar-item-header p,
  .objects-calendar-item-send .list-container .list-tag,
  .objects-calendar-item-send .list-container header p {
    color: #1f497d;
  }
  .objects-calendar-item-send .list-container .tms.toggle,
  .objects-calendar-item-send .list-container .tms2.toggle {
    background-color: #1f497d;
  }
  .objects-calendar-item-send .list-tag-wrapper::-webkit-scrollbar-thumb {
    background: #1f497d;
  }

  /* OK */
  .objects-calendar-item-ok .objects-calendar-item-header {
    background-color: #c5e0b3;
  }
  .objects-calendar-item-ok .list-container {
    background-color: #e2efd9;
  }
  .objects-calendar-item-ok .objects-calendar-item-header p,
  .objects-calendar-item-ok .list-container .list-tag,
  .objects-calendar-item-ok .list-container header p {
    color: #055514;
  }
  .objects-calendar-item-ok .list-container .tms.toggle,
  .objects-calendar-item-ok .list-container .tms2.toggle {
    background-color: #055514;
  }
  .objects-calendar-item-ok .list-tag-wrapper::-webkit-scrollbar-thumb {
    background: #055514;
  }

  /* WAIT */
  .objects-calendar-item-wait .objects-calendar-item-header {
    background-color: #fbd5b5;
  }
  .objects-calendar-item-wait .list-container {
    background-color: #fdeada;
  }
  .objects-calendar-item-wait .objects-calendar-item-header p,
  .objects-calendar-item-wait .list-container .list-tag,
  .objects-calendar-item-wait .list-container header p {
    color: #0058bc;
  }
  .objects-calendar-item-wait .list-container .tms.toggle,
  .objects-calendar-item-wait .list-container .tms2.toggle {
    background-color: #0058bc;
  }
  .objects-calendar-item-wait .list-tag-wrapper::-webkit-scrollbar-thumb {
    background: #0058bc;
  }
  /* * */
  /* PERSONAL */
  /* * */
  .personal-calendar {
    display: block;
  }
  .personal-calendar .big-calendar-item {
    width: 100%;
  }
  .personal-calendar .big-calendar-item-content {
    width: 100%;
  }
  .personal-calendar .personal-tag {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    min-height: 150px;
    padding: 20px 10px;
  }
  .personal-calendar .personal-tag .left {
    border-right: 1px solid #104d80;
    margin-right: 50px;
    padding: 0 8px;
    position: relative;
    width: 50%;
  }
  .personal-calendar .personal-tag .left p {
    text-align: right;
  }
  .personal-calendar .personal-tag .right {
    border-left: 1px solid #104d80;
    margin-left: 50px;
    padding: 0 10px;
    position: relative;
    width: 50%;
  }
  .personal-calendar .personal-tag .right p {
    color: #104d80;
    font-size: 12px;
    line-height: 16px;
    margin: 0;
    opacity: 1;
    text-align: left;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    color: #104d80;
    content: "P";
    font-family: "tms2";
    font-size: 20px;
    position: absolute;
    top: 0;
  }
  .personal-calendar .personal-tag ::before {
    right: -30px;
  }
  .personal-calendar .personal-tag .right::before {
    content: "Q";
    left: -30px;
  }
  .mobile-inline {
    display: none;
  }
  // .mobile-datepicker {
  //   display: none;
  // }
  .new-days {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 5px;
    overflow: auto;
    gap: 5px;
  }
  .planning-toggle {
    align-items: center;
    background: #f2f6f9 0% 0% no-repeat padding-box;
    border: 1px solid #c0cce2;
    border-radius: 4px;
    color: #0057bb;
    cursor: pointer;
    display: flex;
    gap: 5px;
    padding: 0 20px;
    text-align: center;
    user-select: none;
    min-width: 150px;
    min-height: 50px;
    justify-content: center;
    width: 100%;

    &.planning-toggle-small {
      min-width: fit-content;
      p {
        display: none;
      }
    }
    &.planning-toggle--pink {
      background-color: #efddf2;
    }

    .tms {
      font-size: 25px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      text-decoration: underline;
    }

    &:hover {
      opacity: 0.8;
    }
  }
  .plans {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .days {
    display: flex;
    gap: 5px;
    padding: 5px;
    position: relative;
    overflow: auto;

    &.days--groups {
      .day-item {
        min-width: 140px;
        width: 140px;

        > main {
          min-width: initial;

          .group-content {
            .content {
              display: flex;
              height: 100%;
              position: relative;
              min-height: 52px;
              transition: 0.3s all;

              .content__wrap {
                display: flex;
                // overflow: auto;
                transition: 0.3s all;
                width: fit-content;
                min-width: 100%;
              }

              .plans__wrapper {
                display: flex;
                flex-direction: column;
                overflow: auto;
                gap: 2px;
                transition: 0.3s all;
                flex-grow: 2;
                // hide scrolllbar
                -ms-overflow-style: none; /* Internet Explorer 10+ */
                scrollbar-width: none; /* Firefox */
                &::-webkit-scrollbar {
                  display: none; /* Safari and Chrome */
                }
              }
              &.content--hovered {
                background: #117ec8;
                border: 1px solid #117ec8;
                &.content--left {
                  .content__wrap {
                    right: 0;
                    left: initial;
                  }
                }

                .content__wrap {
                  background: #ffffff;
                  box-shadow: 0px 0px 50px #0000008a;
                  border: 1px solid #707070;
                  border-radius: 4px;
                  position: absolute;
                  flex-direction: column-reverse;
                  top: 0;
                  left: 0;
                  overflow: hidden;
                  z-index: 10;

                  &.content__wrap--last {
                    bottom: 0;
                    top: initial;
                  }

                  .plans__wrapper {
                    display: flex;
                    flex-direction: column;
                    overflow: auto;
                    height: fit-content;
                    max-height: 100px;

                    .planning-item-wrapper {
                      min-height: 50px;
                      max-height: initial;

                      .planning-item {
                        > footer {
                          .button-menu {
                            max-height: 45px;
                          }
                        }
                      }
                    }
                  }

                  .planning-toggle {
                    background: #117ec8 0% 0% no-repeat padding-box;
                    border: 1px solid #117ec8;
                    border-radius: 2px;
                    flex-direction: row;
                    min-height: 30px;
                    justify-content: initial;
                    padding: 0 10px;
                    width: 100%;
                    z-index: 15;
                    .tms {
                      flex-grow: initial;
                    }
                  }
                }

                .plans-count {
                  color: #ffffff;
                }
                .planning-toggle {
                  .tms,
                  p {
                    color: #ffffff;
                  }
                }
              }
              &.content--has-plans {
                background: #dde9f2;
                border: 1px solid #7a9fb8;
                border-radius: 2px;

                .planning-toggle {
                  background: initial;
                  border: initial;
                  padding: 0;
                  display: flex;
                  flex-direction: column;
                  justify-items: center;
                  min-width: initial;
                  width: 20%;

                  .tms {
                    font-size: 16px;
                    flex-grow: 2;
                  }
                }
                .plans-count {
                  align-items: center;
                  display: flex;
                  color: #7a9fb8;
                  transform: scale(1.5);

                  &.plans-count--big {
                    &:after {
                      content: "+";
                      font-size: 10px;
                    }
                  }
                }
              }

              &.content--multiple {
                .planning-item-wrapper {
                  &.planning-item-wrapper--basic-view {
                    min-height: calc(50% - 2px);

                    .planning-item {
                      .company-info {
                        p {
                          font-size: 12px;
                          line-height: 10px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      &.days--show-group-users {
        .day-item:first-of-type {
          margin-left: 155px;
        }
      }
      .day-item:first-of-type {
        margin-left: 95px;
      }
    }

    // BASIC VIEW
    &.days--basic-view {
      gap: 0;

      .days-item--groups-aside {
        gap: 0;
      }

      .day-item {
        gap: 0;
        background: initial;
        border: none;
        width: 70px;
        min-width: 70px;

        &.day-item--weekend {
          > header {
            background: #c0cce2;
          }
          > main {
            .plans {
              background-color: rgba(124, 140, 171, 0.2);
            }
          }
        }

        > header {
          background: #ffffff;
          border-radius: initial;

          p {
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column-reverse;
            font-size: 8px;
            justify-content: center;

            strong {
              font-size: 12px;
            }
          }
        }

        > main {
          padding: 12px 0;

          .plans {
            gap: 0;

            .content {
              &.content--selected,
              &.content--selected--add {
                box-shadow: 0px 0px 0px 4px #0057bb, 0px 0px 0px 4px #0057bb;
                position: relative;
                z-index: 5;

                &.content--selected--add {
                  box-shadow: 0px 0px 0px 4px green, 0px 0px 0px 4px green;
                }
              }
              .content__wrap {
                align-items: center;
                background: #ffffff;
                border: 1px solid #032f7f;
                border-radius: initial;
                width: initial;

                .planning-toggle {
                  border-radius: initial;
                }
                .plans__wrapper {
                  height: 100%;
                  width: 100%;

                  .planning-item-wrapper {
                    .planning-item {
                      border-radius: initial;
                      border: initial;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    // BASIC VIEW

    .days--groups-header {
      display: flex;
      flex-direction: column;
    }
  }

  .days-item {
    display: flex;
    gap: 5px;

    &.days-item--groups-aside {
      background: #f2f6f9;
      flex-direction: column;
      top: 38px;
      position: absolute;
      left: 0;
      z-index: 2;
    }

    .planned-objects {
      display: flex;
      gap: 5px;
    }

    &.days-item--non-planned {
      > header {
        background-color: #efddf2;
        border-color: #cbabd1;
        color: #7a1b8a;

        .tms {
          color: #7a1b8a;
        }
      }
    }

    &.days-item--reported {
      > header {
        background: #a6dea4;
        border-color: #187413;
        color: #187413;

        .tms {
          color: #187413;
        }
      }
    }

    > header {
      align-items: center;
      background-color: #dde9f2;
      border: 1px solid #c0cce2;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      font-stretch: 75%;
      justify-content: center;
      gap: 5px;
      padding: 10px;
      position: relative;
      height: fit-content;
      min-height: 52px;
      min-width: 90px;
      text-align: center;
      width: 90px;
      transition: 0.3s all;

      &.header--show-users {
        min-width: 150px;
      }
      &.header--day {
        min-height: 65px;
      }
      .header-group-users {
        display: flex;
        flex-direction: column;
      }
      .tms {
        color: #009cdb;
        font-size: 45px;
        position: absolute;
        opacity: 0.1;
        &.tms--brown {
          color: #443d39;
        }
      }
      > p {
        font-family: "Open Sans";
        font-size: 12px;
        font-weight: 100;
        line-height: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120%;
        white-space: nowrap;
      }
    }
  }
  .day-item {
    background-color: #f2f6f9;
    border: 1px solid #c0cce2;
    border-radius: 4px;
    height: fit-content;
    min-height: 100%;
    position: relative;
    transition: all 0.3s;
    width: fit-content;

    &.day-item--disabled {
      opacity: 0.5;
    }
    &.day-item--hr {
      min-width: 200px;
    }
    // &.day-item--object {
    // min-width: 325px;
    // }

    > header {
      align-items: center;
      background: #c0cce2;
      border: 1px solid #c0cce2;
      border-radius: 4px 4px 0px 0px;
      height: fit-content;
      justify-content: center;
      padding: 5px;
      display: flex;
      height: 25px;
      position: absolute;
      top: 0;
      user-select: none;
      width: 100%;
      z-index: 2;

      p {
        text-transform: uppercase;
      }
      strong {
        text-transform: none;
      }

      main {
        align-items: center;
        display: flex;
        font-size: 14px;
        gap: 5px;
        justify-content: space-between;
        line-height: 14px;
        padding: 5px 8px;
        width: 100%;

        .delete-item {
          margin: 0;
          opacity: 0;
        }
      }

      &:hover {
        .delete-item {
          opacity: 1;
        }
      }
    }

    > main {
      padding: 12px 5px;
      height: 100%;
      margin-top: 20px;
      min-width: 215px;

      hr {
        background: #c0cce2;
        height: 1px;
        margin: 9px 0;
        border: none;
      }
    }

    .planned-objects {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      width: 100%;
      .planned-object {
        align-items: center;
        color: #000;
        display: flex;
        flex-direction: column;
        gap: 3px;
        padding: 20px 0;
        position: relative;
        text-align: center;
        width: 100%;
        &:hover {
          .tms {
            &.delete-item {
              opacity: 1;
            }
          }
        }
        &:not(:first-child) {
          border-top: 1px solid #c0cce2;
        }

        > .tms {
          font-size: 50px;
          margin-bottom: 7px;

          &.delete-item {
            font-size: 20px;
            margin-bottom: 0px;
            position: absolute;
            top: 50%;
            transition: all 0.3s;
            transform: translateX(-50%) translateY(-50%);
            right: -15px;
            opacity: 0;
          }
        }

        p {
          font-size: 9px;

          strong {
            font-size: 12px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .calendar-wrapper {
    .left-panel {
      min-width: 25vw;
      width: 25vw;
    }
  }
}
@media screen and (max-width: 1366px) {
  .calendar-wrapper {
    .left-panel {
      min-width: 28vw;
      width: 28vw;
    }
  }
}
@media screen and (max-width: 1510px) {
  .calendar-wrapper {
    .calendar-header-left {
      position: relative;

      .filters {
        display: none;
        flex-direction: column;
        gap: 10px;
        background: #e6edf3;
        max-width: 300px;
        position: absolute;
        top: calc(100% + 5px);
        right: 10px;
        z-index: 4;

        .checkbox {
          .label {
            max-width: initial;
            white-space: nowrap;
          }
        }

        &.filters--open {
          display: flex;
        }
      }
    }
    .calendar-header-left {
      .views {
        &.views--settings {
          .view {
            border-radius: 4px;
            min-width: fit-content;

            &.view--active {
              background: #840e0e;
              color: #ffffff;

              &.view--fullscreen {
                transform: rotate(-180deg);
              }

              &::before {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .calendar-wrapper {
    .title-and-date {
      height: fit-content;

      .tms {
        display: block;
        font-weight: 100;
      }
      h2,
      .icon-and-text {
        display: none;
      }
      // .icon-and-text {
      //   align-items: flex-start;
      //   gap: 0;
      //   flex-direction: column;
      // }
      .selected-date {
        font-size: 11px;
        padding: 0;
      }
    }
    header {
      &.header--rotate {
        padding: 0;
        min-width: 25px;
        overflow: hidden;
        width: 25px;

        .tms {
          display: none;
          font-size: 25px;
          transform: rotate(-90deg);
        }
        > p {
          transform: rotate(-90deg);
          font-size: 10px;
          line-height: 9px;
          max-width: 50px;
          white-space: initial;
        }
      }
    }
    .days {
      &.days--groups {
        .day-item:first-of-type {
          margin-left: 25px;
        }
      }
    }

    .left-panel-wrapper {
      min-width: fit-content;
      width: fit-content;
    }

    .left-panel {
      box-shadow: 10px 0px 10px #00000080;
      border: 1px solid #c0cce2;
      border-radius: 4px;
      display: none;
      position: absolute;
      min-width: 300px;
      left: 10px;
      z-index: 5;

      &.left-panel--open {
        display: block;
      }
    }
    .desktop {
      display: none;
    }
    .mobile-inline {
      display: inline;
    }
    .calendar {
      padding: 10px 5px;
    }
    .calendar-header {
      gap: 10px;
      height: fit-content;
      position: relative;
    }
    .calendar-header-left {
      // flex-wrap: wrap;
      position: relative;
      width: 100%;

      .views {
        border: none;
        min-width: fit-content;
        &:not(.views--settings) {
          .view {
            opacity: 0.5;
          }
        }
        &.views--settings {
          order: 3;
        }
        &:last-of-type {
          flex-grow: 2;
          max-width: 100%;
        }
        .view {
          color: #374e85;
          flex-direction: column;
          padding: 0 5px;
          width: fit-content;
          .tms {
            font-size: 20px;
          }
          span {
            font-size: 11px;
          }

          &.view--active {
            background: initial;
            position: relative;
            opacity: 1;

            &:before {
              background: #374e85;
              border-radius: 3px;
              content: "";
              height: 3px;
              top: 100%;
              position: absolute;
              width: calc(100% - 10px);
            }
          }

          &:not(:last-child) {
            border: initial;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .calendar-wrapper {
    .mobile-datepicker {
      position: initial;
    }
    .view {
      min-width: 40px;
    }
    .personal-calendar .personal-tag {
      justify-content: center;
      flex-direction: column;
    }
    .personal-calendar .personal-tag .left,
    .personal-calendar .personal-tag .right {
      border-left: 1px solid #104d89;
      border-right: none;
      margin: 0 0 0 35px;
      width: calc(100% - 35px);
    }
    .personal-calendar .personal-tag .left {
      margin-bottom: 10px;
    }
    .personal-calendar .personal-tag .left p,
    .personal-calendar .personal-tag .right p {
      text-align: left;
    }
    .personal-calendar .personal-tag .left::before,
    .personal-calendar .personal-tag .right::before {
      right: initial;
      left: -30px;
    }
    .companies-tag p,
    .personal-tag p {
      font-size: 9px;
      margin: 0;
    }
    .companies-tag p:nth-child(3),
    .personal-tag p:nth-child(3) {
      font-size: 13px;
      margin: 0;
    }
    .personal-calendar .personal-tag .right p {
      font-size: 11px;
      line-height: 14px;
    }
    .no-results-calendar-p {
      font-size: 10px;
    }
  }
}
@media screen and (max-width: 440px) {
  .calendar-wrapper {
    .mobile-datepicker-toggle span {
      font-size: 10px;
    }
    .personal-calendar .personal-tag .left::before,
    .personal-calendar .personal-tag .right::before {
      font-size: 15px;
    }
    .personal-calendar .personal-tag .left,
    .personal-calendar .personal-tag .right {
      width: calc(100% - 25px);
      margin-left: 25px;
    }
    .personal-calendar .personal-tag .left::before,
    .personal-calendar .personal-tag .right::before {
      left: -25px;
    }
  }
}
@media screen and (max-width: 371px) {
  .calendar-wrapper {
    .left-panel {
      top: 120px;
    }
    .calendar-header {
      flex-wrap: wrap;
    }
    .calendar-header-left .filters {
      left: 0px;
      right: initial;
    }
    .title-and-date {
      .icon-and-text {
        align-items: center;
        flex-direction: row;
      }
    }
  }
}
</style>
